/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  GenericScalar: any;
  JSONString: any;
  UUID: any;
  Upload: any;
};

export enum AccountsAgencyCurateInfoSspNameChoices {
  Equativ = 'EQUATIV',
  Pubmatic = 'PUBMATIC',
  Xandr = 'XANDR'
}

export enum AccountsAgencyPartnerChoices {
  Arena = 'ARENA',
  Demo = 'DEMO',
  Equativ = 'EQUATIV',
  Ft = 'FT',
  IndexExchange = 'INDEX_EXCHANGE',
  IrishTimes = 'IRISH_TIMES',
  Magnite = 'MAGNITE',
  NewsUk = 'NEWS_UK',
  Openx = 'OPENX',
  Pubmatic = 'PUBMATIC',
  Ttd = 'TTD',
  Xandr = 'XANDR',
  Yahoo = 'YAHOO'
}

export enum AccountsAgencyProductPriceSupplyChoices {
  Audio = 'AUDIO',
  Ctv = 'CTV',
  Dooh = 'DOOH',
  Web = 'WEB'
}

export enum AccountsErrorCodes {
  InvalidCredentials = 'INVALID_CREDENTIALS'
}

export enum AccountsUserRoleChoices {
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  Buyer = 'BUYER',
  Data = 'DATA',
  Publisher = 'PUBLISHER',
  Sales = 'SALES',
  SeniorManagement = 'SENIOR_MANAGEMENT',
  Tech = 'TECH',
  User = 'USER'
}

export type AgencyCurateInfoType = {
  __typename?: 'AgencyCurateInfoType';
  createdAt: Scalars['DateTime'];
  curateSeatId: Scalars['String'];
  id: Scalars['ID'];
  segments: Array<SegmentType>;
  sspName: AccountsAgencyCurateInfoSspNameChoices;
  updatedAt: Scalars['DateTime'];
};

export type AgencyDspInfoType = {
  __typename?: 'AgencyDSPInfoType';
  createdAt: Scalars['DateTime'];
  dspMemberId: Scalars['String'];
  dspName: DspChoices;
  id: Scalars['ID'];
  isDirect: Scalars['Boolean'];
  segments: Array<SegmentType>;
  updatedAt: Scalars['DateTime'];
};

export type AgencyProductPriceType = {
  __typename?: 'AgencyProductPriceType';
  agency: AgencyType;
  campaignProducts: Array<CampaignProductCategoryType>;
  createdAt: Scalars['DateTime'];
  dsp: DspChoices;
  id: Scalars['ID'];
  price: Scalars['Decimal'];
  product: ProductCategoryChoices;
  segments: Array<SegmentType>;
  supply: Maybe<AccountsAgencyProductPriceSupplyChoices>;
  updatedAt: Scalars['DateTime'];
};

export type AgencyType = {
  __typename?: 'AgencyType';
  createdAt: Scalars['DateTime'];
  curateInfo: Array<AgencyCurateInfoType>;
  dspInfo: Array<AgencyDspInfoType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  partner: Maybe<AccountsAgencyPartnerChoices>;
  prices: Array<AgencyProductPriceType>;
  staff: Array<UserType>;
  updatedAt: Scalars['DateTime'];
};

export type AvailableCampaignsType = {
  __typename?: 'AvailableCampaignsType';
  campaign: CampaignType;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  tableName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BrandType = {
  __typename?: 'BrandType';
  brandCampaigns: CampaignTypeConnection;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  status: Maybe<CampaignsBrandStatusChoices>;
  updatedAt: Scalars['DateTime'];
};


export type BrandTypeBrandCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type CampaignChecklistType = {
  __typename?: 'CampaignChecklistType';
  checkedBy: Maybe<UserType>;
  isResolved: Scalars['Boolean'];
  questionGroup: QuestionGroupChoices;
  questionId: Scalars['ID'];
  questionText: Scalars['String'];
  resolvedAt: Maybe<Scalars['DateTime']>;
};

export type CampaignCommunicationInput = {
  campaignId: Scalars['ID'];
  communicationType: CampaignCommunicationTypeChoices;
  notifyUser?: Maybe<Scalars['Boolean']>;
};

export type CampaignCommunicationMutation = {
  __typename?: 'CampaignCommunicationMutation';
  response: Scalars['String'];
};

export enum CampaignCommunicationTypeChoices {
  CampaignLive = 'CAMPAIGN_LIVE',
  CreativeIdsAudited = 'CREATIVE_IDS_AUDITED',
  IdsGenerated = 'IDS_GENERATED'
}

export type CampaignCreateInput = {
  advertiserName: Scalars['String'];
  averageCpm: Scalars['String'];
  campaignOwnerEmail?: Maybe<Scalars['String']>;
  creativeType: CampaignCreativeTypeChoices;
  curateInfo?: Maybe<CurateInfoInput>;
  dsp: DspInfoInput;
  dspSpecific?: Maybe<Scalars['GenericScalar']>;
  endDate?: Maybe<Scalars['Date']>;
  estimatedIllumaBudget: Scalars['String'];
  estimatedIllumaImpressions: Scalars['Int'];
  isManaged: Scalars['Boolean'];
  kpis: Array<CampaignKpiInput>;
  markets: Array<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productCategories: Array<ProductCategoryInput>;
  startDate: Scalars['Date'];
};

export type CampaignCreativeIdType = {
  __typename?: 'CampaignCreativeIdType';
  createdAt: Scalars['DateTime'];
  creativeId: Scalars['String'];
  id: Scalars['ID'];
  isAudited: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export enum CampaignCreativeTypeChoices {
  Banner = 'BANNER',
  Native = 'NATIVE',
  NotApplicable = 'NOT_APPLICABLE',
  Video = 'VIDEO'
}

export type CampaignDspInfoInput = {
  isDirect?: Maybe<Scalars['Boolean']>;
};

export type CampaignFileType = {
  __typename?: 'CampaignFileType';
  createdAt: Scalars['DateTime'];
  file: Scalars['String'];
  fileType: CampaignsCampaignFileFileTypeChoices;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type CampaignKpiInput = {
  dspSpecificKpiParams?: Maybe<Scalars['GenericScalar']>;
  isPrimary: Scalars['Boolean'];
  kpiTarget: Scalars['String'];
  kpiType: CampaignKpiTypeChoices;
};

export type CampaignKpiType = {
  __typename?: 'CampaignKPIType';
  campaign: CampaignType;
  createdAt: Scalars['DateTime'];
  dspSpecificKpiParams: Maybe<Scalars['JSONString']>;
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  kpiTarget: Scalars['String'];
  kpiType: CampaignKpiTypeChoices;
  updatedAt: Scalars['DateTime'];
};

export enum CampaignKpiTypeChoices {
  Cpa = 'CPA',
  Cpc = 'CPC',
  Cpv = 'CPV',
  Ctr = 'CTR',
  Reach = 'REACH',
  Roas = 'ROAS',
  Vcr = 'VCR',
  Viewability = 'VIEWABILITY',
  WebsiteLands = 'WEBSITE_LANDS'
}

export type CampaignProductCategoryType = {
  __typename?: 'CampaignProductCategoryType';
  createdAt: Scalars['DateTime'];
  customCategories: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  insightCategories: Array<Scalars['String']>;
  precisionCategories: Array<PrecisionCategoriesType>;
  price: Maybe<AgencyProductPriceType>;
  priceList: Maybe<Array<Maybe<AgencyProductPriceType>>>;
  productCategory: ProductCategoryChoices;
  productSupply: Maybe<CampaignsCampaignProductCategoryProductSupplyChoices>;
  updatedAt: Scalars['DateTime'];
};

export type CampaignProductPriceUpdateInput = {
  priceId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
};

export enum CampaignStatusChoices {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Confirmed = 'CONFIRMED',
  Submitted = 'SUBMITTED'
}

export enum CampaignTierChoices {
  Tier_1 = 'TIER_1',
  Tier_2 = 'TIER_2',
  Tier_3 = 'TIER_3'
}

export type CampaignType = Node & {
  __typename?: 'CampaignType';
  accountManager: Maybe<UserType>;
  actualRevenue: FullActualRevenueTypeConnection;
  advertiserName: Scalars['String'];
  availableMetrics: Maybe<Array<InsightMetricsEnum>>;
  averageCpm: Scalars['String'];
  brand: Maybe<BrandType>;
  bundlecontextSet: Array<SegmentBundleContextHandlerType>;
  bundles: Array<SegmentBundleType>;
  campaignExperiments: Array<OptimisationLogType>;
  campaignperformanceviewSet: Array<AvailableCampaignsType>;
  checklist: Array<CampaignChecklistType>;
  createdAt: Scalars['DateTime'];
  creativeIds: Array<CampaignCreativeIdType>;
  creativeType: CampaignCreativeTypeChoices;
  creator: UserType;
  curateInfo: Maybe<AgencyCurateInfoType>;
  dspInfo: AgencyDspInfoType;
  dspSpecific: Maybe<Scalars['JSONString']>;
  endDate: Maybe<Scalars['Date']>;
  estimatedIllumaBudget: Scalars['String'];
  estimatedIllumaImpressions: Scalars['Int'];
  exclusionLists: Array<CampaignFileType>;
  files: Array<CampaignFileType>;
  forecastRevenue: FullForecastRevenueTypeConnection;
  id: Scalars['ID'];
  inclusionLists: Array<CampaignFileType>;
  insightsPermitted: Scalars['Boolean'];
  isApproved: Scalars['Boolean'];
  isManaged: Scalars['Boolean'];
  kpis: Array<CampaignKpiType>;
  markets: Array<CountryType>;
  name: Scalars['String'];
  office: Maybe<OfficeChoices>;
  productCategories: Array<CampaignProductCategoryType>;
  salesPerson: Maybe<UserType>;
  segments: Array<SegmentType>;
  startDate: Scalars['Date'];
  status: CampaignStatusChoices;
  tier: Maybe<CampaignTierChoices>;
  updatedAt: Scalars['DateTime'];
};


export type CampaignTypeActualRevenueArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type CampaignTypeForecastRevenueArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type CampaignTypeConnection = {
  __typename?: 'CampaignTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<CampaignTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type CampaignTypeEdge = {
  __typename?: 'CampaignTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<CampaignType>;
};

export type CampaignUpdateFieldsInput = {
  accountManager?: Maybe<Scalars['ID']>;
  approved?: Maybe<Scalars['Boolean']>;
  averageCpm?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  dspInfo?: Maybe<CampaignDspInfoInput>;
  endDate?: Maybe<Scalars['Date']>;
  estimatedIllumaBudget?: Maybe<Scalars['String']>;
  estimatedIllumaImpressions?: Maybe<Scalars['Int']>;
  insightsPermitted?: Maybe<Scalars['Boolean']>;
  office?: Maybe<OfficeChoices>;
  productPrice?: Maybe<Array<Maybe<CampaignProductPriceUpdateInput>>>;
  salesPerson?: Maybe<Scalars['ID']>;
  tier?: Maybe<CampaignTierChoices>;
};

export enum CampaignsBrandStatusChoices {
  Lapsed = 'LAPSED',
  New = 'NEW',
  Repeat = 'REPEAT'
}

export enum CampaignsCampaignFileFileTypeChoices {
  ExclusionList = 'EXCLUSION_LIST',
  InclusionList = 'INCLUSION_LIST'
}

export enum CampaignsCampaignProductCategoryProductSupplyChoices {
  Audio = 'AUDIO',
  Ctv = 'CTV',
  Dooh = 'DOOH',
  Web = 'WEB'
}

export type CategoryInsightConnection = {
  __typename?: 'CategoryInsightConnection';
  dateRange: DateRangeType;
  edges: Array<CategoryInsightEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CategoryInsightEdge = {
  __typename?: 'CategoryInsightEdge';
  cursor: Scalars['String'];
  node: CategoryInsightNode;
};

export type CategoryInsightNode = InsightNodeInterface & Node & {
  __typename?: 'CategoryInsightNode';
  campaignId: Scalars['ID'];
  category: Scalars['String'];
  dates: Maybe<Array<DateInsightNode>>;
  id: Scalars['ID'];
  insightFilters: Maybe<Scalars['GenericScalar']>;
  insightValues: InsightsValuesType;
  subCategories: Maybe<Array<SubCategoryInsightNode>>;
};

export type CategoryRankingsNode = InsightNodeInterface & Node & {
  __typename?: 'CategoryRankingsNode';
  bottom: Maybe<Array<CategoryInsightNode>>;
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
  insightFilters: Maybe<Scalars['GenericScalar']>;
  insightValues: InsightsValuesType;
  insightsMetric: InsightMetricsEnum;
  top: Maybe<Array<CategoryInsightNode>>;
};

export type CountryType = {
  __typename?: 'CountryType';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CurateInfoInput = {
  curateSeatId: Scalars['String'];
  sspName: SspChoices;
};

export type CustomObtainJsonWebToken = {
  __typename?: 'CustomObtainJSONWebToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export enum DspChoices {
  Adform = 'ADFORM',
  Adobe = 'ADOBE',
  Adtheorent = 'ADTHEORENT',
  AmazonDsp = 'AMAZON_DSP',
  Amobee = 'AMOBEE',
  Beeswax = 'BEESWAX',
  Centro = 'CENTRO',
  Criteo = 'CRITEO',
  Dv360 = 'DV360',
  Mediamath = 'MEDIAMATH',
  PulsePoint = 'PULSE_POINT',
  Roku = 'ROKU',
  Ttd = 'TTD',
  VerizonMedia = 'VERIZON_MEDIA',
  Viant = 'VIANT',
  Xandr = 'XANDR',
  ZetaDsp = 'ZETA_DSP'
}

export type DspInfoInput = {
  dspMemberId: Scalars['String'];
  dspName: DspChoices;
};

export type DateInsightConnection = {
  __typename?: 'DateInsightConnection';
  edges: Array<DateInsightEdge>;
  pageInfo: PageInfo;
};

export type DateInsightEdge = {
  __typename?: 'DateInsightEdge';
  cursor: Scalars['String'];
  node: DateInsightNode;
};

export type DateInsightNode = InsightNodeInterface & Node & {
  __typename?: 'DateInsightNode';
  campaignId: Scalars['ID'];
  categories: Maybe<Array<CategoryInsightNode>>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  insightFilters: Maybe<Scalars['GenericScalar']>;
  insightValues: InsightsValuesType;
};

export type DateRangeInput = {
  endDate?: Maybe<Scalars['Date']>;
  preset?: Maybe<InsightsDateRangePresetsEnum>;
  startDate?: Maybe<Scalars['Date']>;
};

export type DateRangeType = {
  __typename?: 'DateRangeType';
  endDate: Maybe<Scalars['Date']>;
  startDate: Maybe<Scalars['Date']>;
};

export type DealV2Type = {
  __typename?: 'DealV2Type';
  bundles: Array<SegmentBundleType>;
  createdAt: Scalars['DateTime'];
  dealId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: Maybe<SegmentsDealV2PlatformChoices>;
  updatedAt: Scalars['DateTime'];
};

export type DspRevenueType = {
  __typename?: 'DspRevenueType';
  dsp: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
};

export type FullActualRevenueType = Node & {
  __typename?: 'FullActualRevenueType';
  campaign: Maybe<CampaignType>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  revenue: Scalars['Decimal'];
  targetSegmentId: Scalars['String'];
};

export type FullActualRevenueTypeConnection = {
  __typename?: 'FullActualRevenueTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<FullActualRevenueTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type FullActualRevenueTypeEdge = {
  __typename?: 'FullActualRevenueTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<FullActualRevenueType>;
};

export type FullForecastRevenueType = Node & {
  __typename?: 'FullForecastRevenueType';
  campaign: Maybe<CampaignType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  month: Scalars['Int'];
  revenue: Scalars['Decimal'];
  updatedAt: Scalars['DateTime'];
  year: Scalars['Int'];
};

export type FullForecastRevenueTypeConnection = {
  __typename?: 'FullForecastRevenueTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<FullForecastRevenueTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type FullForecastRevenueTypeEdge = {
  __typename?: 'FullForecastRevenueTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<FullForecastRevenueType>;
};

export type FullSalesforceRevenueType = Node & {
  __typename?: 'FullSalesforceRevenueType';
  date: Scalars['Date'];
  id: Scalars['ID'];
  revenue: Scalars['Decimal'];
  salesforceCampaign: Maybe<SalesforceCampaignType>;
};

export type FullSalesforceRevenueTypeConnection = {
  __typename?: 'FullSalesforceRevenueTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<FullSalesforceRevenueTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type FullSalesforceRevenueTypeEdge = {
  __typename?: 'FullSalesforceRevenueTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<FullSalesforceRevenueType>;
};

export enum InsightCategoryChoices {
  Automotive = 'AUTOMOTIVE',
  BusinessAndFinance = 'BUSINESS_AND_FINANCE',
  Education = 'EDUCATION',
  Entertainment = 'ENTERTAINMENT',
  FamilyLife = 'FAMILY_LIFE',
  FoodAndDrink = 'FOOD_AND_DRINK',
  Gaming = 'GAMING',
  Health = 'HEALTH',
  HobbiesAndInterests = 'HOBBIES_AND_INTERESTS',
  NewsAndPolitics = 'NEWS_AND_POLITICS',
  PersonalFinance = 'PERSONAL_FINANCE',
  Shopping = 'SHOPPING',
  Sports = 'SPORTS',
  Technology = 'TECHNOLOGY',
  Travel = 'TRAVEL'
}

export enum InsightMetricsEnum {
  Clicks = 'CLICKS',
  Conversions = 'CONVERSIONS',
  Ctr = 'CTR',
  Impressions = 'IMPRESSIONS'
}

export type InsightNodeInterface = {
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
  insightFilters: Maybe<Scalars['GenericScalar']>;
  insightValues: InsightsValuesType;
};

export enum InsightsDateRangePresetsEnum {
  Last_7Days = 'LAST_7_DAYS',
  Last_14Days = 'LAST_14_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  LastMonth = 'LAST_MONTH',
  ThisMonth = 'THIS_MONTH'
}

export type InsightsValuesType = {
  __typename?: 'InsightsValuesType';
  clicks: Scalars['Int'];
  conversions: Scalars['Int'];
  ctr: Scalars['Float'];
  impressions: Scalars['Int'];
  urlsCountClicks: Scalars['Int'];
  urlsCountConversions: Scalars['Int'];
  urlsCountImpressions: Scalars['Int'];
};

export enum LineTypeChoicesEnum {
  Adgroup = 'ADGROUP',
  Campaign = 'CAMPAIGN',
  LineItem = 'LINE_ITEM',
  Order = 'ORDER',
  Split = 'SPLIT'
}

export type MonthlyDspRevenueType = {
  __typename?: 'MonthlyDspRevenueType';
  dsp: Maybe<Scalars['String']>;
  dspRevenue: Maybe<Array<Maybe<MonthlyRevenueType>>>;
};

export type MonthlyRevenueType = {
  __typename?: 'MonthlyRevenueType';
  month: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  campaignCheck: Maybe<CampaignType>;
  campaignCreate: Maybe<CampaignType>;
  campaignCreativeId: Maybe<CampaignType>;
  campaignUpdate: Maybe<CampaignType>;
  optimisationPackageCreate: Maybe<OptimisationPackageType>;
  packageCreate: Maybe<PackageType>;
  packageUpdate: Maybe<PackageType>;
  passwordReset: Maybe<PasswordResetMutation>;
  predictedUrlUpdate: Maybe<PredictiveCorrectionsType>;
  predictedUrlUpdateTable: Maybe<PredictiveCorrectionsType>;
  reviewUrl: Maybe<ReviewedUrlType>;
  segmentBundleContextHandler: Maybe<SegmentBundleContextHandlerMutation>;
  sendCommunication: Maybe<CampaignCommunicationMutation>;
  userLogin: Maybe<CustomObtainJsonWebToken>;
};


export type MutationCampaignCheckArgs = {
  campaignId: Scalars['ID'];
  questionId: Scalars['ID'];
};


export type MutationCampaignCreateArgs = {
  campaignDetails: CampaignCreateInput;
  exclusionLists?: Maybe<Array<Maybe<Scalars['Upload']>>>;
  inclusionLists?: Maybe<Array<Maybe<Scalars['Upload']>>>;
};


export type MutationCampaignCreativeIdArgs = {
  campaignId: Scalars['ID'];
  creativeId: Scalars['String'];
};


export type MutationCampaignUpdateArgs = {
  campaignId: Scalars['ID'];
  updateFields: CampaignUpdateFieldsInput;
};


export type MutationOptimisationPackageCreateArgs = {
  packageDetails: OptimisationPackageCreateInput;
};


export type MutationPackageCreateArgs = {
  packageDetails: PackageCreateInput;
};


export type MutationPackageUpdateArgs = {
  packageUpdateDetails: PackageUpdateInput;
};


export type MutationPasswordResetArgs = {
  userEmail: Scalars['String'];
};


export type MutationPredictedUrlUpdateArgs = {
  isApproved: Scalars['Boolean'];
  predictedUrlId: Scalars['ID'];
};


export type MutationPredictedUrlUpdateTableArgs = {
  isApproved: Scalars['Boolean'];
  originalClassification?: Maybe<Scalars['String']>;
  predictedFromUrl: Scalars['String'];
  url: Scalars['String'];
};


export type MutationReviewUrlArgs = {
  originalClassification?: Maybe<Scalars['String']>;
  precisionIabV3: Scalars['String'];
  publisher: PublisherChoicesEnum;
  rejectedClassification?: Maybe<Scalars['String']>;
  reviewedClassification?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};


export type MutationSegmentBundleContextHandlerArgs = {
  campaignId: Scalars['ID'];
  dspTacticIds: Array<Maybe<Scalars['String']>>;
  dspTacticLevel: LineTypeChoicesEnum;
  nonIllumaTacticIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  segmentBundleIds: Array<Maybe<Scalars['ID']>>;
};


export type MutationSendCommunicationArgs = {
  communicationDetails: CampaignCommunicationInput;
};


export type MutationUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Node = {
  id: Scalars['ID'];
};

export enum OfficeChoices {
  Row = 'ROW',
  Us = 'US'
}

export type OptimisationLogType = {
  __typename?: 'OptimisationLogType';
  campaign: Maybe<CampaignType>;
  comment: Maybe<Scalars['String']>;
  content: Maybe<Scalars['String']>;
  contentFileInS3: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  experimentId: Scalars['UUID'];
  status: OptimusExperimentLogStatusChoices;
  target: OptimusExperimentLogTargetChoices;
  taskName: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: Maybe<UserType>;
};

export type OptimisationPackageCreateInput = {
  active?: Maybe<Scalars['Boolean']>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  endDate?: Maybe<Scalars['Date']>;
  learnFromIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  orderId: Scalars['String'];
  packageOwnerEmail?: Maybe<Scalars['String']>;
  publisher: PublisherChoicesEnum;
  startDate: Scalars['Date'];
};

export type OptimisationPackageType = Node & {
  __typename?: 'OptimisationPackageType';
  active: Scalars['Boolean'];
  campaignType: Maybe<PartnershipsPublisherOptimisationPackageCampaignTypeChoices>;
  controlLineItemId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Maybe<UserType>;
  deliveryTarget: Maybe<Scalars['Int']>;
  domains: Maybe<Array<Maybe<Scalars['String']>>>;
  endDate: Maybe<Scalars['Date']>;
  exclusionCategories: Array<PrecisionCategoriesType>;
  externalId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalId: Maybe<Scalars['String']>;
  kpiTarget: Maybe<Scalars['Int']>;
  kpiType: Maybe<PartnershipsPublisherOptimisationPackageKpiTypeChoices>;
  learnFromIds: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  numberUniqueUrls: Maybe<Scalars['Int']>;
  orderId: Maybe<Scalars['String']>;
  orderName: Scalars['String'];
  partner: Maybe<PartnershipsPublisherOptimisationPackagePartnerChoices>;
  startDate: Scalars['Date'];
  uniqueId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type OptimisationPackageTypeConnection = {
  __typename?: 'OptimisationPackageTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<OptimisationPackageTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type OptimisationPackageTypeEdge = {
  __typename?: 'OptimisationPackageTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<OptimisationPackageType>;
};

export enum OptimusExperimentLogStatusChoices {
  A_0 = 'A_0',
  A_1 = 'A_1'
}

export enum OptimusExperimentLogTargetChoices {
  A_0 = 'A_0',
  A_1 = 'A_1',
  A_2 = 'A_2',
  A_3 = 'A_3',
  A_4 = 'A_4',
  A_5 = 'A_5',
  A_6 = 'A_6',
  A_7 = 'A_7',
  A_8 = 'A_8',
  A_9 = 'A_9'
}

export type PackageCreateInput = {
  active?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['Date']>;
  expansionCategories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  keywordExclusionList?: Maybe<Scalars['Upload']>;
  keywordInclusionList?: Maybe<Scalars['Upload']>;
  name: Scalars['String'];
  packageOwnerEmail?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
};

export type PackageType = Node & {
  __typename?: 'PackageType';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy: Maybe<UserType>;
  emotionExclusion: Array<Scalars['String']>;
  emotionInclusion: Array<Scalars['String']>;
  endDate: Maybe<Scalars['Date']>;
  exclusionCategories: Array<PrecisionCategoriesType>;
  expansionCategories: Array<PrecisionCategoriesType>;
  externalId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalId: Maybe<Scalars['String']>;
  keywordExclusionList: Maybe<Array<Maybe<Scalars['String']>>>;
  keywordInclusionList: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  partner: Maybe<PartnershipsPublisherPackagePartnerChoices>;
  sentimentExclusion: Maybe<Array<Scalars['String']>>;
  sentimentInclusion: Maybe<Array<Scalars['String']>>;
  startDate: Scalars['Date'];
  uniqueId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PackageTypeConnection = {
  __typename?: 'PackageTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<PackageTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type PackageTypeEdge = {
  __typename?: 'PackageTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<PackageType>;
};

export type PackageUpdateInput = {
  keywordInclusionList?: Maybe<Scalars['Upload']>;
  uniqueId: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Maybe<Scalars['String']>;
};

export enum PartnershipsPublisherOptimisationPackageCampaignTypeChoices {
  BrandedContent = 'BRANDED_CONTENT',
  Display = 'DISPLAY'
}

export enum PartnershipsPublisherOptimisationPackageKpiTypeChoices {
  Clicks = 'CLICKS',
  TimeOnPage = 'TIME_ON_PAGE'
}

export enum PartnershipsPublisherOptimisationPackagePartnerChoices {
  Arena = 'ARENA',
  Demo = 'DEMO',
  Ft = 'FT',
  IrishTimes = 'IRISH_TIMES',
  NewsUk = 'NEWS_UK'
}

export enum PartnershipsPublisherPackagePartnerChoices {
  Arena = 'ARENA',
  Demo = 'DEMO',
  Ft = 'FT',
  IrishTimes = 'IRISH_TIMES',
  NewsUk = 'NEWS_UK'
}

export type PasswordResetMutation = {
  __typename?: 'PasswordResetMutation';
  response: Scalars['String'];
};

export type PrecisionCategoriesListType = {
  __typename?: 'PrecisionCategoriesListType';
  label: Maybe<Scalars['String']>;
  subItems: Maybe<Array<Maybe<PrecisionCategoriesListType>>>;
  value: Maybe<Scalars['Int']>;
};

export type PrecisionCategoriesOptionsType = {
  __typename?: 'PrecisionCategoriesOptionsType';
  children: Maybe<Array<Maybe<Scalars['ID']>>>;
  id: Maybe<Scalars['Int']>;
  label: Maybe<Scalars['String']>;
  parents: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type PrecisionCategoriesType = {
  __typename?: 'PrecisionCategoriesType';
  campaignproductcategorySet: Array<CampaignProductCategoryType>;
  categoriesToExcludeForPublisher: PackageTypeConnection;
  categoriesToExcludeForPublisherOptimisation: OptimisationPackageTypeConnection;
  categoriesToIncludeForPublisher: PackageTypeConnection;
  id: Scalars['ID'];
  tier1: Scalars['String'];
  tier2: Scalars['String'];
  tier3: Scalars['String'];
  tier4: Scalars['String'];
};


export type PrecisionCategoriesTypeCategoriesToExcludeForPublisherArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type PrecisionCategoriesTypeCategoriesToExcludeForPublisherOptimisationArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type PrecisionCategoriesTypeCategoriesToIncludeForPublisherArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PredictedUrlsType = {
  __typename?: 'PredictedUrlsType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isApproved: Maybe<Scalars['Boolean']>;
  originalClassification: Maybe<Scalars['String']>;
  predictedCorrection: Scalars['String'];
  predictedFrom: Scalars['String'];
  reviewedBy: Maybe<UserType>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  urlHash: Maybe<Scalars['String']>;
};

export type PredictiveCorrectionsType = Node & {
  __typename?: 'PredictiveCorrectionsType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isApproved: Maybe<Scalars['Boolean']>;
  originalClassification: Maybe<Scalars['String']>;
  predictedCorrection: Scalars['String'];
  predictedFrom: Scalars['String'];
  reviewedBy: Maybe<UserType>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  urlHash: Maybe<Scalars['String']>;
};

export type PredictiveCorrectionsTypeConnection = {
  __typename?: 'PredictiveCorrectionsTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<PredictiveCorrectionsTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type PredictiveCorrectionsTypeEdge = {
  __typename?: 'PredictiveCorrectionsTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<PredictiveCorrectionsType>;
};

export enum ProductCategoryChoices {
  Compass = 'COMPASS',
  Precision = 'PRECISION',
  PrecisionCtv = 'PRECISION_CTV',
  PrecisionCustom = 'PRECISION_CUSTOM',
  PrecisionSmart = 'PRECISION_SMART',
  Reacts = 'REACTS',
  Smart = 'SMART',
  SmartCtv = 'SMART_CTV'
}

export type ProductCategoryInput = {
  customCategories?: Maybe<Scalars['Upload']>;
  insightCategories?: Maybe<Array<Maybe<InsightCategoryChoices>>>;
  precisionCategories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  productCategory: ProductCategoryChoices;
  productSupply?: Maybe<ProductSupplyChoices>;
};

export enum ProductSupplyChoices {
  Audio = 'AUDIO',
  Ctv = 'CTV',
  Dooh = 'DOOH',
  Web = 'WEB'
}

export enum PublisherChoicesEnum {
  Arena = 'ARENA',
  Demo = 'DEMO',
  IrishTimes = 'IRISH_TIMES',
  NewsUk = 'NEWS_UK'
}

export type Query = {
  __typename?: 'Query';
  accountsErrorCodes: Maybe<AccountsErrorCodes>;
  availableCampaigns: Maybe<Array<Maybe<AvailableCampaignsType>>>;
  brandList: Maybe<Array<Maybe<BrandType>>>;
  campaignBundleList: Maybe<Array<Maybe<SegmentBundleType>>>;
  campaignInfo: Maybe<CampaignType>;
  campaignList: Array<CampaignType>;
  campaignListPaginated: CampaignTypeConnection;
  dealList: Maybe<Array<Maybe<DealV2Type>>>;
  fullActualRevenuePaginated: FullActualRevenueTypeConnection;
  fullForecastRevenuePaginated: FullForecastRevenueTypeConnection;
  fullSalesforceRevenuePaginated: FullSalesforceRevenueTypeConnection;
  insightsByCategoryList: Maybe<CategoryInsightConnection>;
  insightsByDateList: Maybe<DateInsightConnection>;
  insightsCategoryRankings: CategoryRankingsNode;
  me: Maybe<UserType>;
  monthlyAggregatedRevenue: Maybe<Array<Maybe<MonthlyRevenueType>>>;
  monthlyDspRevenue: Maybe<Array<Maybe<MonthlyDspRevenueType>>>;
  node: Maybe<Node>;
  optimisationLogs: Maybe<Array<Maybe<OptimisationLogType>>>;
  optimisationPackageInfo: Maybe<OptimisationPackageType>;
  optimisationPackageListPaginated: OptimisationPackageTypeConnection;
  packageInfo: Maybe<PackageType>;
  packageListPaginated: PackageTypeConnection;
  precisionCategoriesList: Maybe<Array<Maybe<PrecisionCategoriesListType>>>;
  precisionCategoriesOptions: Maybe<Array<Maybe<PrecisionCategoriesOptionsType>>>;
  predictiveCorrections: Maybe<Array<Maybe<PredictiveCorrectionsType>>>;
  predictiveCorrectionsListPaginated: PredictiveCorrectionsTypeConnection;
  predictiveCorrectionsStatus: Maybe<PredictedUrlsType>;
  revenueByDsp: Maybe<Array<Maybe<DspRevenueType>>>;
  reviewedUrl: Maybe<ReviewedUrlType>;
  reviewedUrlsListPaginated: ReviewedUrlTypeConnection;
  segmentBundleList: Maybe<Array<Maybe<SegmentBundleType>>>;
  segmentContextItem: Maybe<Array<Maybe<SegmentBundleContextHandlerType>>>;
  segmentList: Maybe<Array<Maybe<SegmentV2Type>>>;
  targetRevenue: Maybe<TargetRevenueType>;
  usersRoleGroup: Maybe<Array<Maybe<UserType>>>;
};


export type QueryCampaignBundleListArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};


export type QueryCampaignInfoArgs = {
  id: Scalars['ID'];
};


export type QueryCampaignListArgs = {
  filter?: Maybe<CampaignStatusChoices>;
  search?: Maybe<Scalars['String']>;
};


export type QueryCampaignListPaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  filter?: Maybe<CampaignStatusChoices>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryFullActualRevenuePaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  dspFilter?: Maybe<DspChoices>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  officeFilter?: Maybe<OfficeChoices>;
  offset?: Maybe<Scalars['Int']>;
  yearFilter?: Maybe<Scalars['Int']>;
};


export type QueryFullForecastRevenuePaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  dspFilter?: Maybe<DspChoices>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  officeFilter?: Maybe<OfficeChoices>;
  offset?: Maybe<Scalars['Int']>;
  yearFilter?: Maybe<Scalars['Int']>;
};


export type QueryFullSalesforceRevenuePaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  regionFilter?: Maybe<OfficeChoices>;
  yearFilter?: Maybe<Scalars['Int']>;
};


export type QueryInsightsByCategoryListArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  dateRange?: Maybe<DateRangeInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryInsightsByDateListArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  dateRange?: Maybe<DateRangeInput>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryInsightsCategoryRankingsArgs = {
  campaignId: Scalars['ID'];
  dateRange?: Maybe<DateRangeInput>;
  insightsMetric: InsightMetricsEnum;
};


export type QueryMonthlyAggregatedRevenueArgs = {
  dspFilter?: Maybe<DspChoices>;
  isManaged?: Maybe<Scalars['Boolean']>;
  isNoId?: Maybe<Scalars['Boolean']>;
  isNoOffice?: Maybe<Scalars['Boolean']>;
  officeFilter?: Maybe<OfficeChoices>;
  revenueType?: Maybe<RevenueType>;
  yearFilter?: Maybe<Scalars['Int']>;
};


export type QueryMonthlyDspRevenueArgs = {
  dspFilter?: Maybe<DspChoices>;
  officeFilter?: Maybe<OfficeChoices>;
  yearFilter?: Maybe<Scalars['Int']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryOptimisationLogsArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryOptimisationPackageInfoArgs = {
  id: Scalars['ID'];
};


export type QueryOptimisationPackageListPaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryPackageInfoArgs = {
  id: Scalars['ID'];
};


export type QueryPackageListPaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryPredictiveCorrectionsArgs = {
  predictedFromUrl: Scalars['String'];
};


export type QueryPredictiveCorrectionsListPaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryPredictiveCorrectionsStatusArgs = {
  url?: Maybe<Scalars['String']>;
};


export type QueryRevenueByDspArgs = {
  officeFilter?: Maybe<OfficeChoices>;
  yearFilter?: Maybe<Scalars['Int']>;
};


export type QueryReviewedUrlArgs = {
  url: Scalars['String'];
};


export type QueryReviewedUrlsListPaginatedArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  dateRange?: Maybe<ReviewedUrlsDateRangePresetsEnum>;
  filterEndDate?: Maybe<Scalars['Date']>;
  filterStartDate?: Maybe<Scalars['Date']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  publisher: PublisherChoicesEnum;
  search?: Maybe<Scalars['String']>;
};


export type QuerySegmentContextItemArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};


export type QueryTargetRevenueArgs = {
  yearFilter?: Maybe<Scalars['Int']>;
};


export type QueryUsersRoleGroupArgs = {
  role?: Maybe<UserRoleChoices>;
};

export enum QuestionGroupChoices {
  ActiveCampaign = 'ACTIVE_CAMPAIGN',
  PreCampaignChecks = 'PRE_CAMPAIGN_CHECKS'
}

export enum RevenueSalesforceCampaignsRegionChoices {
  Row = 'ROW',
  Us = 'US'
}

export enum RevenueSalesforceCampaignsStageChoices {
  Committed = 'COMMITTED',
  Confident = 'CONFIDENT'
}

export enum RevenueType {
  Actual = 'ACTUAL',
  Forecast = 'FORECAST',
  Salesforce = 'SALESFORCE'
}

export type ReviewedUrlType = Node & {
  __typename?: 'ReviewedURLType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  originalClassification: Maybe<Scalars['String']>;
  precisionIabV3: Scalars['String'];
  publisher: Maybe<UrlHandlerReviewedUrLsPublisherChoices>;
  rejectedClassification: Maybe<Scalars['String']>;
  reviewedBy: Maybe<UserType>;
  reviewedClassification: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  urlHash: Maybe<Scalars['String']>;
};

export type ReviewedUrlTypeConnection = {
  __typename?: 'ReviewedURLTypeConnection';
  edgeCount: Maybe<Scalars['Int']>;
  edges: Array<Maybe<ReviewedUrlTypeEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Int']>;
};

export type ReviewedUrlTypeEdge = {
  __typename?: 'ReviewedURLTypeEdge';
  cursor: Scalars['String'];
  node: Maybe<ReviewedUrlType>;
};

export enum ReviewedUrlsDateRangePresetsEnum {
  All = 'ALL',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_14Days = 'LAST_14_DAYS',
  Last_30Days = 'LAST_30_DAYS'
}

export enum SspChoices {
  Equativ = 'EQUATIV',
  Pubmatic = 'PUBMATIC',
  Xandr = 'XANDR'
}

export type SalesforceCampaignType = {
  __typename?: 'SalesforceCampaignType';
  accountName: Scalars['String'];
  campaignEndDate: Maybe<Scalars['Date']>;
  campaignStartDate: Scalars['Date'];
  createdAt: Scalars['DateTime'];
  forecastRevenue: Scalars['Decimal'];
  id: Scalars['ID'];
  opportunityName: Scalars['String'];
  opportunityOwner: Scalars['String'];
  probability: Scalars['Int'];
  region: Maybe<RevenueSalesforceCampaignsRegionChoices>;
  salesforceRevenue: FullSalesforceRevenueTypeConnection;
  stage: Maybe<RevenueSalesforceCampaignsStageChoices>;
  updatedAt: Scalars['DateTime'];
};


export type SalesforceCampaignTypeSalesforceRevenueArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type SegmentBundleContextHandlerMutation = {
  __typename?: 'SegmentBundleContextHandlerMutation';
  bundleContexts: Maybe<Array<Maybe<SegmentBundleContextHandlerType>>>;
};

export type SegmentBundleContextHandlerType = {
  __typename?: 'SegmentBundleContextHandlerType';
  bundle: SegmentBundleType;
  campaign: CampaignType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  lineType: Maybe<SegmentsBundleContextLineTypeChoices>;
  nonIllumaIds: Maybe<Array<Maybe<Scalars['String']>>>;
  relevantIds: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SegmentBundleType = {
  __typename?: 'SegmentBundleType';
  bundlecontextSet: Array<SegmentBundleContextHandlerType>;
  campaign: CampaignType;
  createdAt: Scalars['DateTime'];
  deal: Maybe<DealV2Type>;
  id: Scalars['ID'];
  segment: Maybe<SegmentV2Type>;
  updatedAt: Scalars['DateTime'];
};

export type SegmentType = {
  __typename?: 'SegmentType';
  campaign: CampaignType;
  createdAt: Scalars['DateTime'];
  dsp: Maybe<AgencyDspInfoType>;
  id: Maybe<Scalars['String']>;
  isDeal: Scalars['Boolean'];
  name: Scalars['String'];
  price: Maybe<AgencyProductPriceType>;
  segmentType: Maybe<SegmentsSegmentSegmentTypeChoices>;
  ssp: Maybe<AgencyCurateInfoType>;
  uniqueId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  wasCategory: Maybe<Scalars['Boolean']>;
};

export type SegmentV2Type = {
  __typename?: 'SegmentV2Type';
  bundles: Array<SegmentBundleType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: Maybe<SegmentsSegmentV2PlatformChoices>;
  segmentId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum SegmentsBundleContextLineTypeChoices {
  Adgroup = 'ADGROUP',
  Campaign = 'CAMPAIGN',
  LineItem = 'LINE_ITEM',
  Order = 'ORDER',
  Split = 'SPLIT'
}

export enum SegmentsDealV2PlatformChoices {
  Pubmatic = 'PUBMATIC',
  Ttd = 'TTD',
  Xandr = 'XANDR'
}

export enum SegmentsSegmentSegmentTypeChoices {
  Category = 'CATEGORY',
  Deal = 'DEAL',
  Segment = 'SEGMENT'
}

export enum SegmentsSegmentV2PlatformChoices {
  Pubmatic = 'PUBMATIC',
  Ttd = 'TTD',
  Xandr = 'XANDR'
}

export type SubCategoryInsightNode = InsightNodeInterface & Node & {
  __typename?: 'SubCategoryInsightNode';
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
  insightFilters: Maybe<Scalars['GenericScalar']>;
  insightValues: InsightsValuesType;
  subCategory: Scalars['String'];
};

export type TargetRevenueType = {
  __typename?: 'TargetRevenueType';
  aprilRow: Scalars['Decimal'];
  aprilUs: Scalars['Decimal'];
  augustRow: Scalars['Decimal'];
  augustUs: Scalars['Decimal'];
  decemberRow: Scalars['Decimal'];
  decemberUs: Scalars['Decimal'];
  februaryRow: Scalars['Decimal'];
  februaryUs: Scalars['Decimal'];
  id: Scalars['UUID'];
  januaryRow: Scalars['Decimal'];
  januaryUs: Scalars['Decimal'];
  julyRow: Scalars['Decimal'];
  julyUs: Scalars['Decimal'];
  juneRow: Scalars['Decimal'];
  juneUs: Scalars['Decimal'];
  marchRow: Scalars['Decimal'];
  marchUs: Scalars['Decimal'];
  mayRow: Scalars['Decimal'];
  mayUs: Scalars['Decimal'];
  novemberRow: Scalars['Decimal'];
  novemberUs: Scalars['Decimal'];
  octoberRow: Scalars['Decimal'];
  octoberUs: Scalars['Decimal'];
  septemberRow: Scalars['Decimal'];
  septemberUs: Scalars['Decimal'];
  year: Scalars['Int'];
};

export enum UrlHandlerReviewedUrLsPublisherChoices {
  Arena = 'ARENA',
  Demo = 'DEMO',
  Ft = 'FT',
  IrishTimes = 'IRISH_TIMES',
  NewsUk = 'NEWS_UK'
}

export enum UserRoleChoices {
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  Buyer = 'BUYER',
  Data = 'DATA',
  Publisher = 'PUBLISHER',
  Sales = 'SALES',
  SeniorManagement = 'SENIOR_MANAGEMENT',
  Tech = 'TECH',
  User = 'USER'
}

export type UserType = {
  __typename?: 'UserType';
  accountManagerCampaigns: CampaignTypeConnection;
  agency: Maybe<AgencyType>;
  campaigns: CampaignTypeConnection;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  isSuperuser: Scalars['Boolean'];
  lastLogin: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  publisherOptimisationPackages: OptimisationPackageTypeConnection;
  publisherPackages: PackageTypeConnection;
  reviewedByUrlHandler: ReviewedUrlTypeConnection;
  reviewedByUrlHandlerPredictiveCorrections: PredictiveCorrectionsTypeConnection;
  role: AccountsUserRoleChoices;
  salesPersonCampaigns: CampaignTypeConnection;
  userExperiments: Array<OptimisationLogType>;
};


export type UserTypeAccountManagerCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type UserTypeCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type UserTypePublisherOptimisationPackagesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type UserTypePublisherPackagesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type UserTypeReviewedByUrlHandlerArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type UserTypeReviewedByUrlHandlerPredictiveCorrectionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type UserTypeSalesPersonCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type CampaignInfoDataFragment = { __typename?: 'CampaignType', id: string, name: string, startDate: any, endDate: any | null, status: CampaignStatusChoices, averageCpm: string, dspSpecific: any | null, availableMetrics: Array<InsightMetricsEnum> | null, insightsPermitted: boolean, office: OfficeChoices | null, tier: CampaignTierChoices | null, creativeType: CampaignCreativeTypeChoices, advertiserName: string, estimatedIllumaBudget: string, estimatedIllumaImpressions: number, exclusionLists: Array<{ __typename?: 'CampaignFileType', id: string }>, inclusionLists: Array<{ __typename?: 'CampaignFileType', id: string }>, dspInfo: { __typename?: 'AgencyDSPInfoType', id: string, dspName: DspChoices, dspMemberId: string, isDirect: boolean }, curateInfo: { __typename?: 'AgencyCurateInfoType', id: string, sspName: AccountsAgencyCurateInfoSspNameChoices, curateSeatId: string } | null, productCategories: Array<{ __typename?: 'CampaignProductCategoryType', id: string, productCategory: ProductCategoryChoices, insightCategories: Array<string>, productSupply: CampaignsCampaignProductCategoryProductSupplyChoices | null, customCategories: Array<string | null> | null, precisionCategories: Array<{ __typename?: 'PrecisionCategoriesType', tier1: string, tier2: string, tier3: string, tier4: string }> }>, markets: Array<{ __typename?: 'CountryType', name: string }>, kpis: Array<{ __typename?: 'CampaignKPIType', id: string, kpiTarget: string, kpiType: CampaignKpiTypeChoices, dspSpecificKpiParams: any | null }>, segments: Array<{ __typename?: 'SegmentType', id: string | null, name: string, segmentType: SegmentsSegmentSegmentTypeChoices | null }>, creativeIds: Array<{ __typename?: 'CampaignCreativeIdType', creativeId: string, isAudited: boolean }> };

export type ProtectedCampaignInfoDataFragment = { __typename?: 'CampaignType', isApproved: boolean, creator: { __typename?: 'UserType', id: any, firstName: string, lastName: string, email: string, agency: { __typename?: 'AgencyType', id: any, name: string } | null }, brand: { __typename?: 'BrandType', id: any, name: string } | null, accountManager: { __typename?: 'UserType', id: any, firstName: string, lastName: string, email: string, agency: { __typename?: 'AgencyType', id: any, name: string } | null } | null, salesPerson: { __typename?: 'UserType', id: any, firstName: string, lastName: string, email: string, agency: { __typename?: 'AgencyType', id: any, name: string } | null } | null, productCategories: Array<{ __typename?: 'CampaignProductCategoryType', priceList: Array<{ __typename?: 'AgencyProductPriceType', id: string, price: any, product: ProductCategoryChoices, dsp: DspChoices } | null> | null, price: { __typename?: 'AgencyProductPriceType', id: string, price: any, product: ProductCategoryChoices, dsp: DspChoices } | null }>, checklist: Array<{ __typename?: 'CampaignChecklistType', questionId: string, questionText: string, questionGroup: QuestionGroupChoices, isResolved: boolean, resolvedAt: any | null, checkedBy: { __typename?: 'UserType', firstName: string, lastName: string } | null }> };

type CampaignInsightValues_CategoryInsightNode_Fragment = { __typename?: 'CategoryInsightNode', id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } };

type CampaignInsightValues_CategoryRankingsNode_Fragment = { __typename?: 'CategoryRankingsNode', id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } };

type CampaignInsightValues_DateInsightNode_Fragment = { __typename?: 'DateInsightNode', id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } };

type CampaignInsightValues_SubCategoryInsightNode_Fragment = { __typename?: 'SubCategoryInsightNode', id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } };

export type CampaignInsightValuesFragment = CampaignInsightValues_CategoryInsightNode_Fragment | CampaignInsightValues_CategoryRankingsNode_Fragment | CampaignInsightValues_DateInsightNode_Fragment | CampaignInsightValues_SubCategoryInsightNode_Fragment;

export type AvailableMetricsFragment = { __typename?: 'CampaignType', availableMetrics: Array<InsightMetricsEnum> | null };

export type CreateCampaignMutationVariables = Exact<{
  campaignDetails: CampaignCreateInput;
  inclusionLists: Maybe<Array<Maybe<Scalars['Upload']>> | Maybe<Scalars['Upload']>>;
  exclusionLists: Maybe<Array<Maybe<Scalars['Upload']>> | Maybe<Scalars['Upload']>>;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', campaignCreate: { __typename?: 'CampaignType', id: string } | null };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
  updateFields: CampaignUpdateFieldsInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', campaignUpdate: { __typename?: 'CampaignType', id: string, name: string, isApproved: boolean, endDate: any | null, estimatedIllumaBudget: string, estimatedIllumaImpressions: number, averageCpm: string, productCategories: Array<{ __typename?: 'CampaignProductCategoryType', id: string, price: { __typename?: 'AgencyProductPriceType', id: string, dsp: DspChoices, price: any, product: ProductCategoryChoices } | null }>, dspInfo: { __typename?: 'AgencyDSPInfoType', id: string, dspName: DspChoices, dspMemberId: string, isDirect: boolean } } | null };

export type CreatePackageMutationVariables = Exact<{
  packageDetails: PackageCreateInput;
}>;


export type CreatePackageMutation = { __typename?: 'Mutation', packageCreate: { __typename?: 'PackageType', uniqueId: string } | null };

export type UpdatePackageMutationVariables = Exact<{
  packageUpdateDetails: PackageUpdateInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', packageUpdate: { __typename?: 'PackageType', uniqueId: string } | null };

export type CreateGamCampaignMutationVariables = Exact<{
  packageDetails: OptimisationPackageCreateInput;
}>;


export type CreateGamCampaignMutation = { __typename?: 'Mutation', optimisationPackageCreate: { __typename?: 'OptimisationPackageType', uniqueId: string } | null };

export type SendCommunicationMutationVariables = Exact<{
  communicationDetails: CampaignCommunicationInput;
}>;


export type SendCommunicationMutation = { __typename?: 'Mutation', sendCommunication: { __typename?: 'CampaignCommunicationMutation', response: string } | null };

export type ChecklistCheckMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  questionId: Scalars['ID'];
}>;


export type ChecklistCheckMutation = { __typename?: 'Mutation', campaignCheck: { __typename?: 'CampaignType', checklist: Array<{ __typename?: 'CampaignChecklistType', questionId: string, questionText: string }> } | null };

export type CampaignCreativeIdMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  creativeId: Scalars['String'];
}>;


export type CampaignCreativeIdMutation = { __typename?: 'Mutation', campaignCreativeId: { __typename?: 'CampaignType', creativeIds: Array<{ __typename?: 'CampaignCreativeIdType', creativeId: string, isAudited: boolean }> } | null };

export type ReviewUrlMutationVariables = Exact<{
  url: Scalars['String'];
  precisionIabV3: Scalars['String'];
  publisher: PublisherChoicesEnum;
  originalClassification: Maybe<Scalars['String']>;
  reviewedClassification: Maybe<Scalars['String']>;
  rejectedClassification: Maybe<Scalars['String']>;
}>;


export type ReviewUrlMutation = { __typename?: 'Mutation', reviewUrl: { __typename?: 'ReviewedURLType', id: string, url: string, originalClassification: string | null, reviewedClassification: string | null, rejectedClassification: string | null } | null };

export type PredictedUrlUpdateMutationVariables = Exact<{
  isApproved: Scalars['Boolean'];
  predictedUrlId: Scalars['ID'];
}>;


export type PredictedUrlUpdateMutation = { __typename?: 'Mutation', predictedUrlUpdate: { __typename?: 'PredictiveCorrectionsType', id: string } | null };

export type PredictedUrlUpdateTableMutationVariables = Exact<{
  isApproved: Scalars['Boolean'];
  originalClassification: Scalars['String'];
  predictedFromUrl: Scalars['String'];
  url: Scalars['String'];
}>;


export type PredictedUrlUpdateTableMutation = { __typename?: 'Mutation', predictedUrlUpdateTable: { __typename?: 'PredictiveCorrectionsType', url: string } | null };

export type ProtectedCampaignInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProtectedCampaignInfoQuery = { __typename?: 'Query', campaignInfo: { __typename?: 'CampaignType', id: string, name: string, startDate: any, endDate: any | null, status: CampaignStatusChoices, averageCpm: string, dspSpecific: any | null, availableMetrics: Array<InsightMetricsEnum> | null, insightsPermitted: boolean, office: OfficeChoices | null, tier: CampaignTierChoices | null, creativeType: CampaignCreativeTypeChoices, advertiserName: string, estimatedIllumaBudget: string, estimatedIllumaImpressions: number, isApproved: boolean, exclusionLists: Array<{ __typename?: 'CampaignFileType', id: string }>, inclusionLists: Array<{ __typename?: 'CampaignFileType', id: string }>, dspInfo: { __typename?: 'AgencyDSPInfoType', id: string, dspName: DspChoices, dspMemberId: string, isDirect: boolean }, curateInfo: { __typename?: 'AgencyCurateInfoType', id: string, sspName: AccountsAgencyCurateInfoSspNameChoices, curateSeatId: string } | null, productCategories: Array<{ __typename?: 'CampaignProductCategoryType', id: string, productCategory: ProductCategoryChoices, insightCategories: Array<string>, productSupply: CampaignsCampaignProductCategoryProductSupplyChoices | null, customCategories: Array<string | null> | null, precisionCategories: Array<{ __typename?: 'PrecisionCategoriesType', tier1: string, tier2: string, tier3: string, tier4: string }>, priceList: Array<{ __typename?: 'AgencyProductPriceType', id: string, price: any, product: ProductCategoryChoices, dsp: DspChoices } | null> | null, price: { __typename?: 'AgencyProductPriceType', id: string, price: any, product: ProductCategoryChoices, dsp: DspChoices } | null }>, markets: Array<{ __typename?: 'CountryType', name: string }>, kpis: Array<{ __typename?: 'CampaignKPIType', id: string, kpiTarget: string, kpiType: CampaignKpiTypeChoices, dspSpecificKpiParams: any | null }>, segments: Array<{ __typename?: 'SegmentType', id: string | null, name: string, segmentType: SegmentsSegmentSegmentTypeChoices | null }>, creativeIds: Array<{ __typename?: 'CampaignCreativeIdType', creativeId: string, isAudited: boolean }>, creator: { __typename?: 'UserType', id: any, firstName: string, lastName: string, email: string, agency: { __typename?: 'AgencyType', id: any, name: string } | null }, brand: { __typename?: 'BrandType', id: any, name: string } | null, accountManager: { __typename?: 'UserType', id: any, firstName: string, lastName: string, email: string, agency: { __typename?: 'AgencyType', id: any, name: string } | null } | null, salesPerson: { __typename?: 'UserType', id: any, firstName: string, lastName: string, email: string, agency: { __typename?: 'AgencyType', id: any, name: string } | null } | null, checklist: Array<{ __typename?: 'CampaignChecklistType', questionId: string, questionText: string, questionGroup: QuestionGroupChoices, isResolved: boolean, resolvedAt: any | null, checkedBy: { __typename?: 'UserType', firstName: string, lastName: string } | null }> } | null };

export type CampaignInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CampaignInfoQuery = { __typename?: 'Query', campaignInfo: { __typename?: 'CampaignType', id: string, name: string, startDate: any, endDate: any | null, status: CampaignStatusChoices, averageCpm: string, dspSpecific: any | null, availableMetrics: Array<InsightMetricsEnum> | null, insightsPermitted: boolean, office: OfficeChoices | null, tier: CampaignTierChoices | null, creativeType: CampaignCreativeTypeChoices, advertiserName: string, estimatedIllumaBudget: string, estimatedIllumaImpressions: number, exclusionLists: Array<{ __typename?: 'CampaignFileType', id: string }>, inclusionLists: Array<{ __typename?: 'CampaignFileType', id: string }>, dspInfo: { __typename?: 'AgencyDSPInfoType', id: string, dspName: DspChoices, dspMemberId: string, isDirect: boolean }, curateInfo: { __typename?: 'AgencyCurateInfoType', id: string, sspName: AccountsAgencyCurateInfoSspNameChoices, curateSeatId: string } | null, productCategories: Array<{ __typename?: 'CampaignProductCategoryType', id: string, productCategory: ProductCategoryChoices, insightCategories: Array<string>, productSupply: CampaignsCampaignProductCategoryProductSupplyChoices | null, customCategories: Array<string | null> | null, precisionCategories: Array<{ __typename?: 'PrecisionCategoriesType', tier1: string, tier2: string, tier3: string, tier4: string }> }>, markets: Array<{ __typename?: 'CountryType', name: string }>, kpis: Array<{ __typename?: 'CampaignKPIType', id: string, kpiTarget: string, kpiType: CampaignKpiTypeChoices, dspSpecificKpiParams: any | null }>, segments: Array<{ __typename?: 'SegmentType', id: string | null, name: string, segmentType: SegmentsSegmentSegmentTypeChoices | null }>, creativeIds: Array<{ __typename?: 'CampaignCreativeIdType', creativeId: string, isAudited: boolean }> } | null };

export type CampaignListPaginatedQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  filter: Maybe<CampaignStatusChoices>;
  first: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
}>;


export type CampaignListPaginatedQuery = { __typename?: 'Query', campaignListPaginated: { __typename?: 'CampaignTypeConnection', totalCount: number | null, edgeCount: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CampaignTypeEdge', node: { __typename?: 'CampaignType', id: string, name: string, startDate: any, endDate: any | null, status: CampaignStatusChoices, availableMetrics: Array<InsightMetricsEnum> | null, creativeType: CampaignCreativeTypeChoices, insightsPermitted: boolean, dspInfo: { __typename?: 'AgencyDSPInfoType', dspName: DspChoices }, creator: { __typename?: 'UserType', agency: { __typename?: 'AgencyType', name: string } | null }, markets: Array<{ __typename?: 'CountryType', code: string, name: string }>, segments: Array<{ __typename?: 'SegmentType', id: string | null, name: string }> } | null } | null> } };

export type PackageInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PackageInfoQuery = { __typename?: 'Query', packageInfo: { __typename?: 'PackageType', uniqueId: string, id: string, name: string | null, active: boolean, startDate: any, endDate: any | null, partner: PartnershipsPublisherPackagePartnerChoices | null, externalId: string | null, keywordExclusionList: Array<string | null> | null, keywordInclusionList: Array<string | null> | null, expansionCategories: Array<{ __typename?: 'PrecisionCategoriesType', tier1: string, tier2: string, tier3: string, tier4: string }> } | null };

export type PackageListPaginatedQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  isActive: Maybe<Scalars['Boolean']>;
  first: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
}>;


export type PackageListPaginatedQuery = { __typename?: 'Query', packageListPaginated: { __typename?: 'PackageTypeConnection', totalCount: number | null, edgeCount: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PackageTypeEdge', node: { __typename?: 'PackageType', id: string, uniqueId: string, internalId: string | null, externalId: string | null, name: string | null, startDate: any, endDate: any | null, partner: PartnershipsPublisherPackagePartnerChoices | null, active: boolean } | null } | null> } };

export type CategoryRankingsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  insightsMetric: InsightMetricsEnum;
  dateRange: Maybe<DateRangeInput>;
}>;


export type CategoryRankingsQuery = { __typename?: 'Query', insightsCategoryRankings: { __typename?: 'CategoryRankingsNode', id: string, top: Array<{ __typename?: 'CategoryInsightNode', category: string, id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } }> | null, bottom: Array<{ __typename?: 'CategoryInsightNode', category: string, id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } }> | null } };

export type CampaignCategoryDateInsightsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  dateRange: Maybe<DateRangeInput>;
}>;


export type CampaignCategoryDateInsightsQuery = { __typename?: 'Query', insightsByCategoryList: { __typename?: 'CategoryInsightConnection', dateRange: { __typename?: 'DateRangeType', startDate: any | null, endDate: any | null }, edges: Array<{ __typename?: 'CategoryInsightEdge', node: { __typename?: 'CategoryInsightNode', id: string, category: string, insightFilters: any | null, dates: Array<{ __typename?: 'DateInsightNode', date: any, id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } }> | null } }> } | null };

export type CampaignCategoryInsightsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  dateRange: Maybe<DateRangeInput>;
}>;


export type CampaignCategoryInsightsQuery = { __typename?: 'Query', insightsByCategoryList: { __typename?: 'CategoryInsightConnection', edges: Array<{ __typename?: 'CategoryInsightEdge', node: { __typename?: 'CategoryInsightNode', id: string, category: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } } }> } | null };

export type CampaignDateInsightsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  dateRange: Maybe<DateRangeInput>;
}>;


export type CampaignDateInsightsQuery = { __typename?: 'Query', insightsByDateList: { __typename?: 'DateInsightConnection', edges: Array<{ __typename?: 'DateInsightEdge', node: { __typename?: 'DateInsightNode', date: any, categories: Array<{ __typename?: 'CategoryInsightNode', category: string, id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } }> | null } }> } | null };

export type SingleCategoryInsightsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleCategoryInsightsQuery = { __typename?: 'Query', node: { __typename?: 'CampaignType' } | { __typename?: 'CategoryInsightNode', category: string, insightFilters: any | null, dates: Array<{ __typename?: 'DateInsightNode', date: any, id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } }> | null, subCategories: Array<{ __typename?: 'SubCategoryInsightNode', subCategory: string, id: string, insightValues: { __typename?: 'InsightsValuesType', impressions: number, clicks: number, conversions: number, urlsCountImpressions: number, urlsCountClicks: number, urlsCountConversions: number, ctr: number } }> | null } | { __typename?: 'CategoryRankingsNode' } | { __typename?: 'DateInsightNode' } | { __typename?: 'FullActualRevenueType' } | { __typename?: 'FullForecastRevenueType' } | { __typename?: 'FullSalesforceRevenueType' } | { __typename?: 'OptimisationPackageType' } | { __typename?: 'PackageType' } | { __typename?: 'PredictiveCorrectionsType' } | { __typename?: 'ReviewedURLType' } | { __typename?: 'SubCategoryInsightNode' } | null };

export type MonthlyAggregatedRevenueQueryVariables = Exact<{
  revenueType: Maybe<RevenueType>;
  dspFilter: Maybe<DspChoices>;
  officeFilter: Maybe<OfficeChoices>;
  isManaged: Maybe<Scalars['Boolean']>;
  isNoId: Maybe<Scalars['Boolean']>;
  isNoOffice: Maybe<Scalars['Boolean']>;
  yearFilter: Maybe<Scalars['Int']>;
}>;


export type MonthlyAggregatedRevenueQuery = { __typename?: 'Query', monthlyAggregatedRevenue: Array<{ __typename?: 'MonthlyRevenueType', month: string | null, revenue: number | null } | null> | null };

export type RevenueByDspQueryVariables = Exact<{
  officeFilter: Maybe<OfficeChoices>;
  yearFilter: Maybe<Scalars['Int']>;
}>;


export type RevenueByDspQuery = { __typename?: 'Query', revenueByDsp: Array<{ __typename?: 'DspRevenueType', dsp: string | null, revenue: number | null } | null> | null };

export type MonthlyDspRevenueQueryVariables = Exact<{
  dspFilter: Maybe<DspChoices>;
  officeFilter: Maybe<OfficeChoices>;
  yearFilter: Maybe<Scalars['Int']>;
}>;


export type MonthlyDspRevenueQuery = { __typename?: 'Query', monthlyDspRevenue: Array<{ __typename?: 'MonthlyDspRevenueType', dsp: string | null, dspRevenue: Array<{ __typename?: 'MonthlyRevenueType', month: string | null, revenue: number | null } | null> | null } | null> | null };

export type TargetRevenueQueryVariables = Exact<{
  yearFilter: Scalars['Int'];
}>;


export type TargetRevenueQuery = { __typename?: 'Query', targetRevenue: { __typename?: 'TargetRevenueType', januaryUs: any, januaryRow: any, februaryUs: any, februaryRow: any, marchUs: any, marchRow: any, aprilUs: any, aprilRow: any, mayUs: any, mayRow: any, juneUs: any, juneRow: any, julyUs: any, julyRow: any, augustUs: any, augustRow: any, septemberUs: any, septemberRow: any, octoberUs: any, octoberRow: any, novemberUs: any, novemberRow: any, decemberUs: any, decemberRow: any } | null };

export type FullActualRevenuePaginatedQueryVariables = Exact<{
  dspFilter: Maybe<DspChoices>;
  officeFilter: Maybe<OfficeChoices>;
  yearFilter: Maybe<Scalars['Int']>;
  first: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
}>;


export type FullActualRevenuePaginatedQuery = { __typename?: 'Query', fullRevenue: { __typename?: 'FullActualRevenueTypeConnection', totalCount: number | null, edges: Array<{ __typename?: 'FullActualRevenueTypeEdge', node: { __typename?: 'FullActualRevenueType', revenue: any, date: any, campaign: { __typename?: 'CampaignType', id: string, name: string, office: OfficeChoices | null, brand: { __typename?: 'BrandType', name: string } | null, accountManager: { __typename?: 'UserType', firstName: string, lastName: string } | null, salesPerson: { __typename?: 'UserType', firstName: string, lastName: string } | null, dspInfo: { __typename?: 'AgencyDSPInfoType', dspName: DspChoices } } | null } | null } | null> } };

export type FullForecastRevenuePaginatedQueryVariables = Exact<{
  dspFilter: Maybe<DspChoices>;
  officeFilter: Maybe<OfficeChoices>;
  yearFilter: Maybe<Scalars['Int']>;
  first: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
}>;


export type FullForecastRevenuePaginatedQuery = { __typename?: 'Query', fullRevenue: { __typename?: 'FullForecastRevenueTypeConnection', totalCount: number | null, edges: Array<{ __typename?: 'FullForecastRevenueTypeEdge', node: { __typename?: 'FullForecastRevenueType', revenue: any, month: number, year: number, campaign: { __typename?: 'CampaignType', id: string, name: string, office: OfficeChoices | null, brand: { __typename?: 'BrandType', name: string } | null, accountManager: { __typename?: 'UserType', firstName: string, lastName: string } | null, salesPerson: { __typename?: 'UserType', firstName: string, lastName: string } | null, dspInfo: { __typename?: 'AgencyDSPInfoType', dspName: DspChoices } } | null } | null } | null> } };

export type FullSalesforceRevenuePaginatedQueryVariables = Exact<{
  regionFilter: Maybe<OfficeChoices>;
  yearFilter: Maybe<Scalars['Int']>;
  first: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
}>;


export type FullSalesforceRevenuePaginatedQuery = { __typename?: 'Query', fullRevenue: { __typename?: 'FullSalesforceRevenueTypeConnection', totalCount: number | null, edges: Array<{ __typename?: 'FullSalesforceRevenueTypeEdge', node: { __typename?: 'FullSalesforceRevenueType', revenue: any, date: any, salesforceCampaign: { __typename?: 'SalesforceCampaignType', id: string, opportunityName: string, opportunityOwner: string, region: RevenueSalesforceCampaignsRegionChoices | null, stage: RevenueSalesforceCampaignsStageChoices | null, accountName: string } | null } | null } | null> } };

export type UsersRoleGroupQueryVariables = Exact<{
  role: Maybe<UserRoleChoices>;
}>;


export type UsersRoleGroupQuery = { __typename?: 'Query', usersRoleGroup: Array<{ __typename?: 'UserType', id: any, firstName: string, lastName: string, isStaff: boolean, role: AccountsUserRoleChoices } | null> | null };

export type BrandListQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandListQuery = { __typename?: 'Query', brandList: Array<{ __typename?: 'BrandType', id: any, name: string } | null> | null };

export type PrecisionCategoriesListQueryVariables = Exact<{ [key: string]: never; }>;


export type PrecisionCategoriesListQuery = { __typename?: 'Query', precisionCategoriesList: Array<{ __typename?: 'PrecisionCategoriesListType', value: number | null, label: string | null, subItems: Array<{ __typename?: 'PrecisionCategoriesListType', value: number | null, label: string | null, subItems: Array<{ __typename?: 'PrecisionCategoriesListType', value: number | null, label: string | null, subItems: Array<{ __typename?: 'PrecisionCategoriesListType', value: number | null, label: string | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type PrecisionCategoriesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PrecisionCategoriesOptionsQuery = { __typename?: 'Query', precisionCategoriesOptions: Array<{ __typename?: 'PrecisionCategoriesOptionsType', id: number | null, label: string | null, children: Array<string | null> | null, parents: Array<string | null> | null } | null> | null };

export type ReviewedUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type ReviewedUrlQuery = { __typename?: 'Query', reviewedUrl: { __typename?: 'ReviewedURLType', url: string, createdAt: any, precisionIabV3: string, originalClassification: string | null, reviewedClassification: string | null, rejectedClassification: string | null, reviewedBy: { __typename?: 'UserType', firstName: string, lastName: string } | null } | null };

export type PredictiveCorrectionsQueryVariables = Exact<{
  predictedFromUrl: Scalars['String'];
}>;


export type PredictiveCorrectionsQuery = { __typename?: 'Query', predictiveCorrections: Array<{ __typename?: 'PredictiveCorrectionsType', url: string, predictedFrom: string, predictedCorrection: string, id: string, isApproved: boolean | null } | null> | null };

export type ReviewedUrlsListPaginatedQueryVariables = Exact<{
  publisher: PublisherChoicesEnum;
  search: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  dateRange: Maybe<ReviewedUrlsDateRangePresetsEnum>;
  offset: Maybe<Scalars['Int']>;
  before: Maybe<Scalars['String']>;
  after: Maybe<Scalars['String']>;
  first: Maybe<Scalars['Int']>;
  last: Maybe<Scalars['Int']>;
  filterStartDate: Maybe<Scalars['Date']>;
  filterEndDate: Maybe<Scalars['Date']>;
}>;


export type ReviewedUrlsListPaginatedQuery = { __typename?: 'Query', reviewedUrlsListPaginated: { __typename?: 'ReviewedURLTypeConnection', totalCount: number | null, pageInfo: { __typename?: 'PageInfo', startCursor: string | null, endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ReviewedURLTypeEdge', node: { __typename?: 'ReviewedURLType', id: string, url: string } | null } | null> } };

export type ReviewedUrlsListPaginatedDownloadQueryVariables = Exact<{
  publisher: PublisherChoicesEnum;
  search: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  dateRange: Maybe<ReviewedUrlsDateRangePresetsEnum>;
  filterStartDate: Maybe<Scalars['Date']>;
  filterEndDate: Maybe<Scalars['Date']>;
  offset: Maybe<Scalars['Int']>;
  before: Maybe<Scalars['String']>;
  after: Maybe<Scalars['String']>;
  first: Maybe<Scalars['Int']>;
  last: Maybe<Scalars['Int']>;
}>;


export type ReviewedUrlsListPaginatedDownloadQuery = { __typename?: 'Query', reviewedUrlsListPaginated: { __typename?: 'ReviewedURLTypeConnection', totalCount: number | null, pageInfo: { __typename?: 'PageInfo', startCursor: string | null, endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ReviewedURLTypeEdge', node: { __typename?: 'ReviewedURLType', id: string, url: string, reviewedClassification: string | null, rejectedClassification: string | null, originalClassification: string | null, createdAt: any, reviewedBy: { __typename?: 'UserType', email: string } | null } | null } | null> } };

export type PredictiveCorrectionsListPaginatedQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  offset: Maybe<Scalars['Int']>;
  before: Maybe<Scalars['String']>;
  after: Maybe<Scalars['String']>;
  first: Maybe<Scalars['Int']>;
  last: Maybe<Scalars['Int']>;
}>;


export type PredictiveCorrectionsListPaginatedQuery = { __typename?: 'Query', predictiveCorrectionsListPaginated: { __typename?: 'PredictiveCorrectionsTypeConnection', totalCount: number | null, pageInfo: { __typename?: 'PageInfo', startCursor: string | null, endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PredictiveCorrectionsTypeEdge', node: { __typename?: 'PredictiveCorrectionsType', id: string, predictedFrom: string } | null } | null> } };

export type OptimisationLogsQueryVariables = Exact<{
  campaignId: Maybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type OptimisationLogsQuery = { __typename?: 'Query', optimisationLogs: Array<{ __typename?: 'OptimisationLogType', createdAt: any, taskName: string | null, user: { __typename?: 'UserType', firstName: string, lastName: string } | null } | null> | null };

export type AvailableCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCampaignsQuery = { __typename?: 'Query', availableCampaigns: Array<{ __typename?: 'AvailableCampaignsType', tableName: string, campaign: { __typename?: 'CampaignType', id: string, name: string, dspSpecific: any | null, dspInfo: { __typename?: 'AgencyDSPInfoType', dspName: DspChoices } } } | null> | null };

export type CampaignListQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  filter: Maybe<CampaignStatusChoices>;
}>;


export type CampaignListQuery = { __typename?: 'Query', campaignList: Array<{ __typename?: 'CampaignType', name: string, id: string, dspSpecific: any | null, dspInfo: { __typename?: 'AgencyDSPInfoType', dspName: DspChoices } }> };

export type OptimisationPackageInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OptimisationPackageInfoQuery = { __typename?: 'Query', optimisationPackageInfo: { __typename?: 'OptimisationPackageType', name: string | null, startDate: any, endDate: any | null, active: boolean, externalId: string | null, orderId: string | null, learnFromIds: Array<string | null> | null, domains: Array<string | null> | null } | null };

export type OptimisationPackageListPaginatedQueryVariables = Exact<{
  search: Maybe<Scalars['String']>;
  isActive: Maybe<Scalars['Boolean']>;
  first: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
}>;


export type OptimisationPackageListPaginatedQuery = { __typename?: 'Query', optimisationPackageListPaginated: { __typename?: 'OptimisationPackageTypeConnection', totalCount: number | null, edgeCount: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'OptimisationPackageTypeEdge', node: { __typename?: 'OptimisationPackageType', uniqueId: string, name: string | null, startDate: any, endDate: any | null, partner: PartnershipsPublisherOptimisationPackagePartnerChoices | null, active: boolean } | null } | null> } };

export type PredictiveCorrectionsStatusQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type PredictiveCorrectionsStatusQuery = { __typename?: 'Query', predictiveCorrectionsStatus: { __typename?: 'PredictedUrlsType', url: string, isApproved: boolean | null, originalClassification: string | null, predictedCorrection: string } | null };

export type SegmentBundleListQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentBundleListQuery = { __typename?: 'Query', segmentBundleList: Array<{ __typename?: 'SegmentBundleType', id: string, segment: { __typename?: 'SegmentV2Type', id: string, name: string } | null, deal: { __typename?: 'DealV2Type', id: string, name: string } | null } | null> | null };

export type CampaignBundleListQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type CampaignBundleListQuery = { __typename?: 'Query', campaignBundleList: Array<{ __typename?: 'SegmentBundleType', id: string, segment: { __typename?: 'SegmentV2Type', id: string, name: string, segmentId: string } | null, deal: { __typename?: 'DealV2Type', id: string, name: string, dealId: string } | null } | null> | null };

export type BundleContextHandlerMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  dspTacticIds: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
  dspTacticLevel: LineTypeChoicesEnum;
  segmentBundleIds: Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>;
  nonIllumaTacticIds: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type BundleContextHandlerMutation = { __typename?: 'Mutation', segmentBundleContextHandler: { __typename?: 'SegmentBundleContextHandlerMutation', bundleContexts: Array<{ __typename?: 'SegmentBundleContextHandlerType', campaign: { __typename?: 'CampaignType', name: string } } | null> | null } | null };

export type SegmentContextItemQueryVariables = Exact<{
  campaignId: Maybe<Scalars['ID']>;
}>;


export type SegmentContextItemQuery = { __typename?: 'Query', segmentContextItem: Array<{ __typename?: 'SegmentBundleContextHandlerType', id: string, lineType: SegmentsBundleContextLineTypeChoices | null, relevantIds: Array<string>, nonIllumaIds: Array<string | null> | null, campaign: { __typename?: 'CampaignType', id: string, name: string, dspInfo: { __typename?: 'AgencyDSPInfoType', dspName: DspChoices } }, bundle: { __typename?: 'SegmentBundleType', id: string, segment: { __typename?: 'SegmentV2Type', id: string, name: string, segmentId: string } | null, deal: { __typename?: 'DealV2Type', id: string, name: string, dealId: string } | null } } | null> | null };

export type SegmentListQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentListQuery = { __typename?: 'Query', segmentList: Array<{ __typename?: 'SegmentV2Type', id: string, name: string, segmentId: string, bundles: Array<{ __typename?: 'SegmentBundleType', id: string, segment: { __typename?: 'SegmentV2Type', id: string, name: string } | null, deal: { __typename?: 'DealV2Type', id: string, name: string, dealId: string } | null }> } | null> | null };

export type DealListQueryVariables = Exact<{ [key: string]: never; }>;


export type DealListQuery = { __typename?: 'Query', dealList: Array<{ __typename?: 'DealV2Type', id: string, name: string, dealId: string, bundles: Array<{ __typename?: 'SegmentBundleType', id: string, segment: { __typename?: 'SegmentV2Type', id: string, name: string, segmentId: string } | null, deal: { __typename?: 'DealV2Type', id: string, name: string } | null }> } | null> | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', userLogin: { __typename?: 'CustomObtainJSONWebToken', token: string } | null };

export type GetUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDetailsQuery = { __typename?: 'Query', me: { __typename?: 'UserType', id: any, firstName: string, lastName: string, isStaff: boolean, role: AccountsUserRoleChoices, agency: { __typename?: 'AgencyType', partner: AccountsAgencyPartnerChoices | null, name: string } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  userEmail: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', passwordReset: { __typename?: 'PasswordResetMutation', response: string } | null };

export const CampaignInfoDataFragmentDoc = gql`
    fragment CampaignInfoData on CampaignType {
  id
  name
  startDate
  endDate
  status
  averageCpm
  dspSpecific
  availableMetrics
  insightsPermitted
  office
  tier
  exclusionLists {
    id
  }
  inclusionLists {
    id
  }
  dspInfo {
    id
    dspName
    dspMemberId
    isDirect
  }
  curateInfo {
    id
    sspName
    curateSeatId
  }
  productCategories {
    id
    productCategory
    insightCategories
    precisionCategories {
      tier1
      tier2
      tier3
      tier4
    }
    productSupply
    customCategories
  }
  creativeType
  markets {
    name
  }
  advertiserName
  kpis {
    id
    kpiTarget
    kpiType
    dspSpecificKpiParams
  }
  estimatedIllumaBudget
  estimatedIllumaImpressions
  segments {
    id
    name
    segmentType
  }
  creativeIds {
    creativeId
    isAudited
  }
}
    `;
export const ProtectedCampaignInfoDataFragmentDoc = gql`
    fragment ProtectedCampaignInfoData on CampaignType {
  creator {
    id
    firstName
    lastName
    email
    agency {
      id
      name
    }
  }
  brand {
    id
    name
  }
  accountManager {
    id
    firstName
    lastName
    email
    agency {
      id
      name
    }
  }
  salesPerson {
    id
    firstName
    lastName
    email
    agency {
      id
      name
    }
  }
  productCategories {
    priceList {
      id
      price
      product
      dsp
    }
    price {
      id
      price
      product
      dsp
    }
  }
  isApproved
  checklist {
    questionId
    questionText
    questionGroup
    checkedBy {
      firstName
      lastName
    }
    isResolved
    resolvedAt
  }
}
    `;
export const CampaignInsightValuesFragmentDoc = gql`
    fragment CampaignInsightValues on InsightNodeInterface {
  id
  insightValues {
    impressions
    clicks
    conversions
    urlsCountImpressions
    urlsCountClicks
    urlsCountConversions
    ctr
  }
}
    `;
export const AvailableMetricsFragmentDoc = gql`
    fragment AvailableMetrics on CampaignType {
  availableMetrics
}
    `;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($campaignDetails: CampaignCreateInput!, $inclusionLists: [Upload], $exclusionLists: [Upload]) {
  campaignCreate(
    campaignDetails: $campaignDetails
    inclusionLists: $inclusionLists
    exclusionLists: $exclusionLists
  ) {
    id
  }
}
    `;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      campaignDetails: // value for 'campaignDetails'
 *      inclusionLists: // value for 'inclusionLists'
 *      exclusionLists: // value for 'exclusionLists'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($id: ID!, $updateFields: CampaignUpdateFieldsInput!) {
  campaignUpdate(campaignId: $id, updateFields: $updateFields) {
    id
    name
    productCategories {
      id
      price {
        id
        dsp
        price
        product
      }
    }
    isApproved
    endDate
    estimatedIllumaBudget
    estimatedIllumaImpressions
    averageCpm
    dspInfo {
      id
      dspName
      dspMemberId
      isDirect
    }
  }
}
    `;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateFields: // value for 'updateFields'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const CreatePackageDocument = gql`
    mutation CreatePackage($packageDetails: PackageCreateInput!) {
  packageCreate(packageDetails: $packageDetails) {
    uniqueId
  }
}
    `;
export type CreatePackageMutationFn = Apollo.MutationFunction<CreatePackageMutation, CreatePackageMutationVariables>;

/**
 * __useCreatePackageMutation__
 *
 * To run a mutation, you first call `useCreatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageMutation, { data, loading, error }] = useCreatePackageMutation({
 *   variables: {
 *      packageDetails: // value for 'packageDetails'
 *   },
 * });
 */
export function useCreatePackageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageMutation, CreatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageMutation, CreatePackageMutationVariables>(CreatePackageDocument, options);
      }
export type CreatePackageMutationHookResult = ReturnType<typeof useCreatePackageMutation>;
export type CreatePackageMutationResult = Apollo.MutationResult<CreatePackageMutation>;
export type CreatePackageMutationOptions = Apollo.BaseMutationOptions<CreatePackageMutation, CreatePackageMutationVariables>;
export const UpdatePackageDocument = gql`
    mutation UpdatePackage($packageUpdateDetails: PackageUpdateInput!) {
  packageUpdate(packageUpdateDetails: $packageUpdateDetails) {
    uniqueId
  }
}
    `;
export type UpdatePackageMutationFn = Apollo.MutationFunction<UpdatePackageMutation, UpdatePackageMutationVariables>;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      packageUpdateDetails: // value for 'packageUpdateDetails'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageMutation, UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;
export type UpdatePackageMutationResult = Apollo.MutationResult<UpdatePackageMutation>;
export type UpdatePackageMutationOptions = Apollo.BaseMutationOptions<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const CreateGamCampaignDocument = gql`
    mutation CreateGamCampaign($packageDetails: OptimisationPackageCreateInput!) {
  optimisationPackageCreate(packageDetails: $packageDetails) {
    uniqueId
  }
}
    `;
export type CreateGamCampaignMutationFn = Apollo.MutationFunction<CreateGamCampaignMutation, CreateGamCampaignMutationVariables>;

/**
 * __useCreateGamCampaignMutation__
 *
 * To run a mutation, you first call `useCreateGamCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGamCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGamCampaignMutation, { data, loading, error }] = useCreateGamCampaignMutation({
 *   variables: {
 *      packageDetails: // value for 'packageDetails'
 *   },
 * });
 */
export function useCreateGamCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateGamCampaignMutation, CreateGamCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGamCampaignMutation, CreateGamCampaignMutationVariables>(CreateGamCampaignDocument, options);
      }
export type CreateGamCampaignMutationHookResult = ReturnType<typeof useCreateGamCampaignMutation>;
export type CreateGamCampaignMutationResult = Apollo.MutationResult<CreateGamCampaignMutation>;
export type CreateGamCampaignMutationOptions = Apollo.BaseMutationOptions<CreateGamCampaignMutation, CreateGamCampaignMutationVariables>;
export const SendCommunicationDocument = gql`
    mutation SendCommunication($communicationDetails: CampaignCommunicationInput!) {
  sendCommunication(communicationDetails: $communicationDetails) {
    response
  }
}
    `;
export type SendCommunicationMutationFn = Apollo.MutationFunction<SendCommunicationMutation, SendCommunicationMutationVariables>;

/**
 * __useSendCommunicationMutation__
 *
 * To run a mutation, you first call `useSendCommunicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommunicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommunicationMutation, { data, loading, error }] = useSendCommunicationMutation({
 *   variables: {
 *      communicationDetails: // value for 'communicationDetails'
 *   },
 * });
 */
export function useSendCommunicationMutation(baseOptions?: Apollo.MutationHookOptions<SendCommunicationMutation, SendCommunicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCommunicationMutation, SendCommunicationMutationVariables>(SendCommunicationDocument, options);
      }
export type SendCommunicationMutationHookResult = ReturnType<typeof useSendCommunicationMutation>;
export type SendCommunicationMutationResult = Apollo.MutationResult<SendCommunicationMutation>;
export type SendCommunicationMutationOptions = Apollo.BaseMutationOptions<SendCommunicationMutation, SendCommunicationMutationVariables>;
export const ChecklistCheckDocument = gql`
    mutation ChecklistCheck($campaignId: ID!, $questionId: ID!) {
  campaignCheck(campaignId: $campaignId, questionId: $questionId) {
    checklist {
      questionId
      questionText
    }
  }
}
    `;
export type ChecklistCheckMutationFn = Apollo.MutationFunction<ChecklistCheckMutation, ChecklistCheckMutationVariables>;

/**
 * __useChecklistCheckMutation__
 *
 * To run a mutation, you first call `useChecklistCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChecklistCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checklistCheckMutation, { data, loading, error }] = useChecklistCheckMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useChecklistCheckMutation(baseOptions?: Apollo.MutationHookOptions<ChecklistCheckMutation, ChecklistCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChecklistCheckMutation, ChecklistCheckMutationVariables>(ChecklistCheckDocument, options);
      }
export type ChecklistCheckMutationHookResult = ReturnType<typeof useChecklistCheckMutation>;
export type ChecklistCheckMutationResult = Apollo.MutationResult<ChecklistCheckMutation>;
export type ChecklistCheckMutationOptions = Apollo.BaseMutationOptions<ChecklistCheckMutation, ChecklistCheckMutationVariables>;
export const CampaignCreativeIdDocument = gql`
    mutation CampaignCreativeId($campaignId: ID!, $creativeId: String!) {
  campaignCreativeId(campaignId: $campaignId, creativeId: $creativeId) {
    creativeIds {
      creativeId
      isAudited
    }
  }
}
    `;
export type CampaignCreativeIdMutationFn = Apollo.MutationFunction<CampaignCreativeIdMutation, CampaignCreativeIdMutationVariables>;

/**
 * __useCampaignCreativeIdMutation__
 *
 * To run a mutation, you first call `useCampaignCreativeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCreativeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCreativeIdMutation, { data, loading, error }] = useCampaignCreativeIdMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      creativeId: // value for 'creativeId'
 *   },
 * });
 */
export function useCampaignCreativeIdMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCreativeIdMutation, CampaignCreativeIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCreativeIdMutation, CampaignCreativeIdMutationVariables>(CampaignCreativeIdDocument, options);
      }
export type CampaignCreativeIdMutationHookResult = ReturnType<typeof useCampaignCreativeIdMutation>;
export type CampaignCreativeIdMutationResult = Apollo.MutationResult<CampaignCreativeIdMutation>;
export type CampaignCreativeIdMutationOptions = Apollo.BaseMutationOptions<CampaignCreativeIdMutation, CampaignCreativeIdMutationVariables>;
export const ReviewUrlDocument = gql`
    mutation ReviewUrl($url: String!, $precisionIabV3: String!, $publisher: PublisherChoicesEnum!, $originalClassification: String, $reviewedClassification: String, $rejectedClassification: String) {
  reviewUrl(
    url: $url
    precisionIabV3: $precisionIabV3
    publisher: $publisher
    originalClassification: $originalClassification
    reviewedClassification: $reviewedClassification
    rejectedClassification: $rejectedClassification
  ) {
    id
    url
    originalClassification
    reviewedClassification
    rejectedClassification
  }
}
    `;
export type ReviewUrlMutationFn = Apollo.MutationFunction<ReviewUrlMutation, ReviewUrlMutationVariables>;

/**
 * __useReviewUrlMutation__
 *
 * To run a mutation, you first call `useReviewUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewUrlMutation, { data, loading, error }] = useReviewUrlMutation({
 *   variables: {
 *      url: // value for 'url'
 *      precisionIabV3: // value for 'precisionIabV3'
 *      publisher: // value for 'publisher'
 *      originalClassification: // value for 'originalClassification'
 *      reviewedClassification: // value for 'reviewedClassification'
 *      rejectedClassification: // value for 'rejectedClassification'
 *   },
 * });
 */
export function useReviewUrlMutation(baseOptions?: Apollo.MutationHookOptions<ReviewUrlMutation, ReviewUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewUrlMutation, ReviewUrlMutationVariables>(ReviewUrlDocument, options);
      }
export type ReviewUrlMutationHookResult = ReturnType<typeof useReviewUrlMutation>;
export type ReviewUrlMutationResult = Apollo.MutationResult<ReviewUrlMutation>;
export type ReviewUrlMutationOptions = Apollo.BaseMutationOptions<ReviewUrlMutation, ReviewUrlMutationVariables>;
export const PredictedUrlUpdateDocument = gql`
    mutation PredictedUrlUpdate($isApproved: Boolean!, $predictedUrlId: ID!) {
  predictedUrlUpdate(isApproved: $isApproved, predictedUrlId: $predictedUrlId) {
    id
  }
}
    `;
export type PredictedUrlUpdateMutationFn = Apollo.MutationFunction<PredictedUrlUpdateMutation, PredictedUrlUpdateMutationVariables>;

/**
 * __usePredictedUrlUpdateMutation__
 *
 * To run a mutation, you first call `usePredictedUrlUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePredictedUrlUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [predictedUrlUpdateMutation, { data, loading, error }] = usePredictedUrlUpdateMutation({
 *   variables: {
 *      isApproved: // value for 'isApproved'
 *      predictedUrlId: // value for 'predictedUrlId'
 *   },
 * });
 */
export function usePredictedUrlUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PredictedUrlUpdateMutation, PredictedUrlUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PredictedUrlUpdateMutation, PredictedUrlUpdateMutationVariables>(PredictedUrlUpdateDocument, options);
      }
export type PredictedUrlUpdateMutationHookResult = ReturnType<typeof usePredictedUrlUpdateMutation>;
export type PredictedUrlUpdateMutationResult = Apollo.MutationResult<PredictedUrlUpdateMutation>;
export type PredictedUrlUpdateMutationOptions = Apollo.BaseMutationOptions<PredictedUrlUpdateMutation, PredictedUrlUpdateMutationVariables>;
export const PredictedUrlUpdateTableDocument = gql`
    mutation PredictedUrlUpdateTable($isApproved: Boolean!, $originalClassification: String!, $predictedFromUrl: String!, $url: String!) {
  predictedUrlUpdateTable(
    isApproved: $isApproved
    originalClassification: $originalClassification
    predictedFromUrl: $predictedFromUrl
    url: $url
  ) {
    url
  }
}
    `;
export type PredictedUrlUpdateTableMutationFn = Apollo.MutationFunction<PredictedUrlUpdateTableMutation, PredictedUrlUpdateTableMutationVariables>;

/**
 * __usePredictedUrlUpdateTableMutation__
 *
 * To run a mutation, you first call `usePredictedUrlUpdateTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePredictedUrlUpdateTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [predictedUrlUpdateTableMutation, { data, loading, error }] = usePredictedUrlUpdateTableMutation({
 *   variables: {
 *      isApproved: // value for 'isApproved'
 *      originalClassification: // value for 'originalClassification'
 *      predictedFromUrl: // value for 'predictedFromUrl'
 *      url: // value for 'url'
 *   },
 * });
 */
export function usePredictedUrlUpdateTableMutation(baseOptions?: Apollo.MutationHookOptions<PredictedUrlUpdateTableMutation, PredictedUrlUpdateTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PredictedUrlUpdateTableMutation, PredictedUrlUpdateTableMutationVariables>(PredictedUrlUpdateTableDocument, options);
      }
export type PredictedUrlUpdateTableMutationHookResult = ReturnType<typeof usePredictedUrlUpdateTableMutation>;
export type PredictedUrlUpdateTableMutationResult = Apollo.MutationResult<PredictedUrlUpdateTableMutation>;
export type PredictedUrlUpdateTableMutationOptions = Apollo.BaseMutationOptions<PredictedUrlUpdateTableMutation, PredictedUrlUpdateTableMutationVariables>;
export const ProtectedCampaignInfoDocument = gql`
    query ProtectedCampaignInfo($id: ID!) {
  campaignInfo(id: $id) {
    ...CampaignInfoData
    ...ProtectedCampaignInfoData
  }
}
    ${CampaignInfoDataFragmentDoc}
${ProtectedCampaignInfoDataFragmentDoc}`;

/**
 * __useProtectedCampaignInfoQuery__
 *
 * To run a query within a React component, call `useProtectedCampaignInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProtectedCampaignInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProtectedCampaignInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProtectedCampaignInfoQuery(baseOptions: Apollo.QueryHookOptions<ProtectedCampaignInfoQuery, ProtectedCampaignInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProtectedCampaignInfoQuery, ProtectedCampaignInfoQueryVariables>(ProtectedCampaignInfoDocument, options);
      }
export function useProtectedCampaignInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProtectedCampaignInfoQuery, ProtectedCampaignInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProtectedCampaignInfoQuery, ProtectedCampaignInfoQueryVariables>(ProtectedCampaignInfoDocument, options);
        }
export type ProtectedCampaignInfoQueryHookResult = ReturnType<typeof useProtectedCampaignInfoQuery>;
export type ProtectedCampaignInfoLazyQueryHookResult = ReturnType<typeof useProtectedCampaignInfoLazyQuery>;
export type ProtectedCampaignInfoQueryResult = Apollo.QueryResult<ProtectedCampaignInfoQuery, ProtectedCampaignInfoQueryVariables>;
export const CampaignInfoDocument = gql`
    query CampaignInfo($id: ID!) {
  campaignInfo(id: $id) {
    ...CampaignInfoData
  }
}
    ${CampaignInfoDataFragmentDoc}`;

/**
 * __useCampaignInfoQuery__
 *
 * To run a query within a React component, call `useCampaignInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignInfoQuery(baseOptions: Apollo.QueryHookOptions<CampaignInfoQuery, CampaignInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignInfoQuery, CampaignInfoQueryVariables>(CampaignInfoDocument, options);
      }
export function useCampaignInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignInfoQuery, CampaignInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignInfoQuery, CampaignInfoQueryVariables>(CampaignInfoDocument, options);
        }
export type CampaignInfoQueryHookResult = ReturnType<typeof useCampaignInfoQuery>;
export type CampaignInfoLazyQueryHookResult = ReturnType<typeof useCampaignInfoLazyQuery>;
export type CampaignInfoQueryResult = Apollo.QueryResult<CampaignInfoQuery, CampaignInfoQueryVariables>;
export const CampaignListPaginatedDocument = gql`
    query CampaignListPaginated($search: String, $filter: CampaignStatusChoices, $first: Int, $offset: Int) {
  campaignListPaginated(
    search: $search
    filter: $filter
    first: $first
    offset: $offset
  ) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        name
        startDate
        endDate
        status
        availableMetrics
        creativeType
        insightsPermitted
        dspInfo {
          dspName
        }
        creator {
          agency {
            name
          }
        }
        markets {
          code
          name
        }
        segments {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignListPaginatedQuery__
 *
 * To run a query within a React component, call `useCampaignListPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignListPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignListPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCampaignListPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<CampaignListPaginatedQuery, CampaignListPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignListPaginatedQuery, CampaignListPaginatedQueryVariables>(CampaignListPaginatedDocument, options);
      }
export function useCampaignListPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignListPaginatedQuery, CampaignListPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignListPaginatedQuery, CampaignListPaginatedQueryVariables>(CampaignListPaginatedDocument, options);
        }
export type CampaignListPaginatedQueryHookResult = ReturnType<typeof useCampaignListPaginatedQuery>;
export type CampaignListPaginatedLazyQueryHookResult = ReturnType<typeof useCampaignListPaginatedLazyQuery>;
export type CampaignListPaginatedQueryResult = Apollo.QueryResult<CampaignListPaginatedQuery, CampaignListPaginatedQueryVariables>;
export const PackageInfoDocument = gql`
    query PackageInfo($id: ID!) {
  packageInfo(id: $id) {
    uniqueId
    id
    name
    active
    startDate
    endDate
    partner
    externalId
    keywordExclusionList
    keywordInclusionList
    expansionCategories {
      tier1
      tier2
      tier3
      tier4
    }
  }
}
    `;

/**
 * __usePackageInfoQuery__
 *
 * To run a query within a React component, call `usePackageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackageInfoQuery(baseOptions: Apollo.QueryHookOptions<PackageInfoQuery, PackageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageInfoQuery, PackageInfoQueryVariables>(PackageInfoDocument, options);
      }
export function usePackageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageInfoQuery, PackageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageInfoQuery, PackageInfoQueryVariables>(PackageInfoDocument, options);
        }
export type PackageInfoQueryHookResult = ReturnType<typeof usePackageInfoQuery>;
export type PackageInfoLazyQueryHookResult = ReturnType<typeof usePackageInfoLazyQuery>;
export type PackageInfoQueryResult = Apollo.QueryResult<PackageInfoQuery, PackageInfoQueryVariables>;
export const PackageListPaginatedDocument = gql`
    query PackageListPaginated($search: String, $isActive: Boolean, $first: Int, $offset: Int) {
  packageListPaginated(
    search: $search
    isActive: $isActive
    first: $first
    offset: $offset
  ) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        uniqueId
        internalId
        externalId
        name
        startDate
        endDate
        partner
        active
      }
    }
  }
}
    `;

/**
 * __usePackageListPaginatedQuery__
 *
 * To run a query within a React component, call `usePackageListPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageListPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageListPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      isActive: // value for 'isActive'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usePackageListPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<PackageListPaginatedQuery, PackageListPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageListPaginatedQuery, PackageListPaginatedQueryVariables>(PackageListPaginatedDocument, options);
      }
export function usePackageListPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageListPaginatedQuery, PackageListPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageListPaginatedQuery, PackageListPaginatedQueryVariables>(PackageListPaginatedDocument, options);
        }
export type PackageListPaginatedQueryHookResult = ReturnType<typeof usePackageListPaginatedQuery>;
export type PackageListPaginatedLazyQueryHookResult = ReturnType<typeof usePackageListPaginatedLazyQuery>;
export type PackageListPaginatedQueryResult = Apollo.QueryResult<PackageListPaginatedQuery, PackageListPaginatedQueryVariables>;
export const CategoryRankingsDocument = gql`
    query CategoryRankings($campaignId: ID!, $insightsMetric: InsightMetricsEnum!, $dateRange: DateRangeInput) {
  insightsCategoryRankings(
    campaignId: $campaignId
    insightsMetric: $insightsMetric
    dateRange: $dateRange
  ) {
    id
    top {
      category
      ...CampaignInsightValues
    }
    bottom {
      category
      ...CampaignInsightValues
    }
  }
}
    ${CampaignInsightValuesFragmentDoc}`;

/**
 * __useCategoryRankingsQuery__
 *
 * To run a query within a React component, call `useCategoryRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryRankingsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      insightsMetric: // value for 'insightsMetric'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useCategoryRankingsQuery(baseOptions: Apollo.QueryHookOptions<CategoryRankingsQuery, CategoryRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryRankingsQuery, CategoryRankingsQueryVariables>(CategoryRankingsDocument, options);
      }
export function useCategoryRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryRankingsQuery, CategoryRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryRankingsQuery, CategoryRankingsQueryVariables>(CategoryRankingsDocument, options);
        }
export type CategoryRankingsQueryHookResult = ReturnType<typeof useCategoryRankingsQuery>;
export type CategoryRankingsLazyQueryHookResult = ReturnType<typeof useCategoryRankingsLazyQuery>;
export type CategoryRankingsQueryResult = Apollo.QueryResult<CategoryRankingsQuery, CategoryRankingsQueryVariables>;
export const CampaignCategoryDateInsightsDocument = gql`
    query CampaignCategoryDateInsights($campaignId: ID!, $dateRange: DateRangeInput) {
  insightsByCategoryList(campaignId: $campaignId, dateRange: $dateRange) {
    dateRange {
      startDate
      endDate
    }
    edges {
      node {
        id
        category
        insightFilters
        dates {
          date
          ...CampaignInsightValues
        }
      }
    }
  }
}
    ${CampaignInsightValuesFragmentDoc}`;

/**
 * __useCampaignCategoryDateInsightsQuery__
 *
 * To run a query within a React component, call `useCampaignCategoryDateInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignCategoryDateInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignCategoryDateInsightsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useCampaignCategoryDateInsightsQuery(baseOptions: Apollo.QueryHookOptions<CampaignCategoryDateInsightsQuery, CampaignCategoryDateInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignCategoryDateInsightsQuery, CampaignCategoryDateInsightsQueryVariables>(CampaignCategoryDateInsightsDocument, options);
      }
export function useCampaignCategoryDateInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignCategoryDateInsightsQuery, CampaignCategoryDateInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignCategoryDateInsightsQuery, CampaignCategoryDateInsightsQueryVariables>(CampaignCategoryDateInsightsDocument, options);
        }
export type CampaignCategoryDateInsightsQueryHookResult = ReturnType<typeof useCampaignCategoryDateInsightsQuery>;
export type CampaignCategoryDateInsightsLazyQueryHookResult = ReturnType<typeof useCampaignCategoryDateInsightsLazyQuery>;
export type CampaignCategoryDateInsightsQueryResult = Apollo.QueryResult<CampaignCategoryDateInsightsQuery, CampaignCategoryDateInsightsQueryVariables>;
export const CampaignCategoryInsightsDocument = gql`
    query CampaignCategoryInsights($campaignId: ID!, $dateRange: DateRangeInput) {
  insightsByCategoryList(campaignId: $campaignId, dateRange: $dateRange) {
    edges {
      node {
        id
        category
        ...CampaignInsightValues
      }
    }
  }
}
    ${CampaignInsightValuesFragmentDoc}`;

/**
 * __useCampaignCategoryInsightsQuery__
 *
 * To run a query within a React component, call `useCampaignCategoryInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignCategoryInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignCategoryInsightsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useCampaignCategoryInsightsQuery(baseOptions: Apollo.QueryHookOptions<CampaignCategoryInsightsQuery, CampaignCategoryInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignCategoryInsightsQuery, CampaignCategoryInsightsQueryVariables>(CampaignCategoryInsightsDocument, options);
      }
export function useCampaignCategoryInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignCategoryInsightsQuery, CampaignCategoryInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignCategoryInsightsQuery, CampaignCategoryInsightsQueryVariables>(CampaignCategoryInsightsDocument, options);
        }
export type CampaignCategoryInsightsQueryHookResult = ReturnType<typeof useCampaignCategoryInsightsQuery>;
export type CampaignCategoryInsightsLazyQueryHookResult = ReturnType<typeof useCampaignCategoryInsightsLazyQuery>;
export type CampaignCategoryInsightsQueryResult = Apollo.QueryResult<CampaignCategoryInsightsQuery, CampaignCategoryInsightsQueryVariables>;
export const CampaignDateInsightsDocument = gql`
    query CampaignDateInsights($campaignId: ID!, $dateRange: DateRangeInput) {
  insightsByDateList(campaignId: $campaignId, dateRange: $dateRange) {
    edges {
      node {
        date
        categories {
          category
          ...CampaignInsightValues
        }
      }
    }
  }
}
    ${CampaignInsightValuesFragmentDoc}`;

/**
 * __useCampaignDateInsightsQuery__
 *
 * To run a query within a React component, call `useCampaignDateInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDateInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDateInsightsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useCampaignDateInsightsQuery(baseOptions: Apollo.QueryHookOptions<CampaignDateInsightsQuery, CampaignDateInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDateInsightsQuery, CampaignDateInsightsQueryVariables>(CampaignDateInsightsDocument, options);
      }
export function useCampaignDateInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDateInsightsQuery, CampaignDateInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDateInsightsQuery, CampaignDateInsightsQueryVariables>(CampaignDateInsightsDocument, options);
        }
export type CampaignDateInsightsQueryHookResult = ReturnType<typeof useCampaignDateInsightsQuery>;
export type CampaignDateInsightsLazyQueryHookResult = ReturnType<typeof useCampaignDateInsightsLazyQuery>;
export type CampaignDateInsightsQueryResult = Apollo.QueryResult<CampaignDateInsightsQuery, CampaignDateInsightsQueryVariables>;
export const SingleCategoryInsightsDocument = gql`
    query SingleCategoryInsights($id: ID!) {
  node(id: $id) {
    ... on CategoryInsightNode {
      category
      insightFilters
      dates {
        date
        ...CampaignInsightValues
      }
      subCategories {
        subCategory
        ...CampaignInsightValues
      }
    }
  }
}
    ${CampaignInsightValuesFragmentDoc}`;

/**
 * __useSingleCategoryInsightsQuery__
 *
 * To run a query within a React component, call `useSingleCategoryInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCategoryInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCategoryInsightsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleCategoryInsightsQuery(baseOptions: Apollo.QueryHookOptions<SingleCategoryInsightsQuery, SingleCategoryInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCategoryInsightsQuery, SingleCategoryInsightsQueryVariables>(SingleCategoryInsightsDocument, options);
      }
export function useSingleCategoryInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCategoryInsightsQuery, SingleCategoryInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCategoryInsightsQuery, SingleCategoryInsightsQueryVariables>(SingleCategoryInsightsDocument, options);
        }
export type SingleCategoryInsightsQueryHookResult = ReturnType<typeof useSingleCategoryInsightsQuery>;
export type SingleCategoryInsightsLazyQueryHookResult = ReturnType<typeof useSingleCategoryInsightsLazyQuery>;
export type SingleCategoryInsightsQueryResult = Apollo.QueryResult<SingleCategoryInsightsQuery, SingleCategoryInsightsQueryVariables>;
export const MonthlyAggregatedRevenueDocument = gql`
    query MonthlyAggregatedRevenue($revenueType: RevenueType, $dspFilter: DSPChoices, $officeFilter: OfficeChoices, $isManaged: Boolean, $isNoId: Boolean, $isNoOffice: Boolean, $yearFilter: Int) {
  monthlyAggregatedRevenue(
    revenueType: $revenueType
    dspFilter: $dspFilter
    officeFilter: $officeFilter
    isManaged: $isManaged
    isNoId: $isNoId
    isNoOffice: $isNoOffice
    yearFilter: $yearFilter
  ) {
    month
    revenue
  }
}
    `;

/**
 * __useMonthlyAggregatedRevenueQuery__
 *
 * To run a query within a React component, call `useMonthlyAggregatedRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyAggregatedRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyAggregatedRevenueQuery({
 *   variables: {
 *      revenueType: // value for 'revenueType'
 *      dspFilter: // value for 'dspFilter'
 *      officeFilter: // value for 'officeFilter'
 *      isManaged: // value for 'isManaged'
 *      isNoId: // value for 'isNoId'
 *      isNoOffice: // value for 'isNoOffice'
 *      yearFilter: // value for 'yearFilter'
 *   },
 * });
 */
export function useMonthlyAggregatedRevenueQuery(baseOptions?: Apollo.QueryHookOptions<MonthlyAggregatedRevenueQuery, MonthlyAggregatedRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyAggregatedRevenueQuery, MonthlyAggregatedRevenueQueryVariables>(MonthlyAggregatedRevenueDocument, options);
      }
export function useMonthlyAggregatedRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyAggregatedRevenueQuery, MonthlyAggregatedRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyAggregatedRevenueQuery, MonthlyAggregatedRevenueQueryVariables>(MonthlyAggregatedRevenueDocument, options);
        }
export type MonthlyAggregatedRevenueQueryHookResult = ReturnType<typeof useMonthlyAggregatedRevenueQuery>;
export type MonthlyAggregatedRevenueLazyQueryHookResult = ReturnType<typeof useMonthlyAggregatedRevenueLazyQuery>;
export type MonthlyAggregatedRevenueQueryResult = Apollo.QueryResult<MonthlyAggregatedRevenueQuery, MonthlyAggregatedRevenueQueryVariables>;
export const RevenueByDspDocument = gql`
    query RevenueByDsp($officeFilter: OfficeChoices, $yearFilter: Int) {
  revenueByDsp(officeFilter: $officeFilter, yearFilter: $yearFilter) {
    dsp
    revenue
  }
}
    `;

/**
 * __useRevenueByDspQuery__
 *
 * To run a query within a React component, call `useRevenueByDspQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueByDspQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevenueByDspQuery({
 *   variables: {
 *      officeFilter: // value for 'officeFilter'
 *      yearFilter: // value for 'yearFilter'
 *   },
 * });
 */
export function useRevenueByDspQuery(baseOptions?: Apollo.QueryHookOptions<RevenueByDspQuery, RevenueByDspQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevenueByDspQuery, RevenueByDspQueryVariables>(RevenueByDspDocument, options);
      }
export function useRevenueByDspLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevenueByDspQuery, RevenueByDspQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevenueByDspQuery, RevenueByDspQueryVariables>(RevenueByDspDocument, options);
        }
export type RevenueByDspQueryHookResult = ReturnType<typeof useRevenueByDspQuery>;
export type RevenueByDspLazyQueryHookResult = ReturnType<typeof useRevenueByDspLazyQuery>;
export type RevenueByDspQueryResult = Apollo.QueryResult<RevenueByDspQuery, RevenueByDspQueryVariables>;
export const MonthlyDspRevenueDocument = gql`
    query MonthlyDspRevenue($dspFilter: DSPChoices, $officeFilter: OfficeChoices, $yearFilter: Int) {
  monthlyDspRevenue(
    dspFilter: $dspFilter
    officeFilter: $officeFilter
    yearFilter: $yearFilter
  ) {
    dsp
    dspRevenue {
      month
      revenue
    }
  }
}
    `;

/**
 * __useMonthlyDspRevenueQuery__
 *
 * To run a query within a React component, call `useMonthlyDspRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyDspRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyDspRevenueQuery({
 *   variables: {
 *      dspFilter: // value for 'dspFilter'
 *      officeFilter: // value for 'officeFilter'
 *      yearFilter: // value for 'yearFilter'
 *   },
 * });
 */
export function useMonthlyDspRevenueQuery(baseOptions?: Apollo.QueryHookOptions<MonthlyDspRevenueQuery, MonthlyDspRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyDspRevenueQuery, MonthlyDspRevenueQueryVariables>(MonthlyDspRevenueDocument, options);
      }
export function useMonthlyDspRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyDspRevenueQuery, MonthlyDspRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyDspRevenueQuery, MonthlyDspRevenueQueryVariables>(MonthlyDspRevenueDocument, options);
        }
export type MonthlyDspRevenueQueryHookResult = ReturnType<typeof useMonthlyDspRevenueQuery>;
export type MonthlyDspRevenueLazyQueryHookResult = ReturnType<typeof useMonthlyDspRevenueLazyQuery>;
export type MonthlyDspRevenueQueryResult = Apollo.QueryResult<MonthlyDspRevenueQuery, MonthlyDspRevenueQueryVariables>;
export const TargetRevenueDocument = gql`
    query TargetRevenue($yearFilter: Int!) {
  targetRevenue(yearFilter: $yearFilter) {
    januaryUs
    januaryRow
    februaryUs
    februaryRow
    marchUs
    marchRow
    aprilUs
    aprilRow
    mayUs
    mayRow
    juneUs
    juneRow
    julyUs
    julyRow
    augustUs
    augustRow
    septemberUs
    septemberRow
    octoberUs
    octoberRow
    novemberUs
    novemberRow
    decemberUs
    decemberRow
  }
}
    `;

/**
 * __useTargetRevenueQuery__
 *
 * To run a query within a React component, call `useTargetRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetRevenueQuery({
 *   variables: {
 *      yearFilter: // value for 'yearFilter'
 *   },
 * });
 */
export function useTargetRevenueQuery(baseOptions: Apollo.QueryHookOptions<TargetRevenueQuery, TargetRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetRevenueQuery, TargetRevenueQueryVariables>(TargetRevenueDocument, options);
      }
export function useTargetRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetRevenueQuery, TargetRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetRevenueQuery, TargetRevenueQueryVariables>(TargetRevenueDocument, options);
        }
export type TargetRevenueQueryHookResult = ReturnType<typeof useTargetRevenueQuery>;
export type TargetRevenueLazyQueryHookResult = ReturnType<typeof useTargetRevenueLazyQuery>;
export type TargetRevenueQueryResult = Apollo.QueryResult<TargetRevenueQuery, TargetRevenueQueryVariables>;
export const FullActualRevenuePaginatedDocument = gql`
    query FullActualRevenuePaginated($dspFilter: DSPChoices, $officeFilter: OfficeChoices, $yearFilter: Int, $first: Int, $offset: Int) {
  fullRevenue: fullActualRevenuePaginated(
    dspFilter: $dspFilter
    officeFilter: $officeFilter
    yearFilter: $yearFilter
    first: $first
    offset: $offset
  ) {
    totalCount
    edges {
      node {
        campaign {
          id
          name
          office
          brand {
            name
          }
          accountManager {
            firstName
            lastName
          }
          salesPerson {
            firstName
            lastName
          }
          dspInfo {
            dspName
          }
        }
        revenue
        date
      }
    }
  }
}
    `;

/**
 * __useFullActualRevenuePaginatedQuery__
 *
 * To run a query within a React component, call `useFullActualRevenuePaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullActualRevenuePaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullActualRevenuePaginatedQuery({
 *   variables: {
 *      dspFilter: // value for 'dspFilter'
 *      officeFilter: // value for 'officeFilter'
 *      yearFilter: // value for 'yearFilter'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFullActualRevenuePaginatedQuery(baseOptions?: Apollo.QueryHookOptions<FullActualRevenuePaginatedQuery, FullActualRevenuePaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullActualRevenuePaginatedQuery, FullActualRevenuePaginatedQueryVariables>(FullActualRevenuePaginatedDocument, options);
      }
export function useFullActualRevenuePaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullActualRevenuePaginatedQuery, FullActualRevenuePaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullActualRevenuePaginatedQuery, FullActualRevenuePaginatedQueryVariables>(FullActualRevenuePaginatedDocument, options);
        }
export type FullActualRevenuePaginatedQueryHookResult = ReturnType<typeof useFullActualRevenuePaginatedQuery>;
export type FullActualRevenuePaginatedLazyQueryHookResult = ReturnType<typeof useFullActualRevenuePaginatedLazyQuery>;
export type FullActualRevenuePaginatedQueryResult = Apollo.QueryResult<FullActualRevenuePaginatedQuery, FullActualRevenuePaginatedQueryVariables>;
export const FullForecastRevenuePaginatedDocument = gql`
    query FullForecastRevenuePaginated($dspFilter: DSPChoices, $officeFilter: OfficeChoices, $yearFilter: Int, $first: Int, $offset: Int) {
  fullRevenue: fullForecastRevenuePaginated(
    dspFilter: $dspFilter
    officeFilter: $officeFilter
    yearFilter: $yearFilter
    first: $first
    offset: $offset
  ) {
    totalCount
    edges {
      node {
        campaign {
          id
          name
          office
          brand {
            name
          }
          accountManager {
            firstName
            lastName
          }
          salesPerson {
            firstName
            lastName
          }
          dspInfo {
            dspName
          }
        }
        revenue
        month
        year
      }
    }
  }
}
    `;

/**
 * __useFullForecastRevenuePaginatedQuery__
 *
 * To run a query within a React component, call `useFullForecastRevenuePaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullForecastRevenuePaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullForecastRevenuePaginatedQuery({
 *   variables: {
 *      dspFilter: // value for 'dspFilter'
 *      officeFilter: // value for 'officeFilter'
 *      yearFilter: // value for 'yearFilter'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFullForecastRevenuePaginatedQuery(baseOptions?: Apollo.QueryHookOptions<FullForecastRevenuePaginatedQuery, FullForecastRevenuePaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullForecastRevenuePaginatedQuery, FullForecastRevenuePaginatedQueryVariables>(FullForecastRevenuePaginatedDocument, options);
      }
export function useFullForecastRevenuePaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullForecastRevenuePaginatedQuery, FullForecastRevenuePaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullForecastRevenuePaginatedQuery, FullForecastRevenuePaginatedQueryVariables>(FullForecastRevenuePaginatedDocument, options);
        }
export type FullForecastRevenuePaginatedQueryHookResult = ReturnType<typeof useFullForecastRevenuePaginatedQuery>;
export type FullForecastRevenuePaginatedLazyQueryHookResult = ReturnType<typeof useFullForecastRevenuePaginatedLazyQuery>;
export type FullForecastRevenuePaginatedQueryResult = Apollo.QueryResult<FullForecastRevenuePaginatedQuery, FullForecastRevenuePaginatedQueryVariables>;
export const FullSalesforceRevenuePaginatedDocument = gql`
    query FullSalesforceRevenuePaginated($regionFilter: OfficeChoices, $yearFilter: Int, $first: Int, $offset: Int) {
  fullRevenue: fullSalesforceRevenuePaginated(
    regionFilter: $regionFilter
    yearFilter: $yearFilter
    first: $first
    offset: $offset
  ) {
    totalCount
    edges {
      node {
        salesforceCampaign {
          id
          opportunityName
          opportunityOwner
          region
          stage
          accountName
        }
        revenue
        date
      }
    }
  }
}
    `;

/**
 * __useFullSalesforceRevenuePaginatedQuery__
 *
 * To run a query within a React component, call `useFullSalesforceRevenuePaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullSalesforceRevenuePaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullSalesforceRevenuePaginatedQuery({
 *   variables: {
 *      regionFilter: // value for 'regionFilter'
 *      yearFilter: // value for 'yearFilter'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFullSalesforceRevenuePaginatedQuery(baseOptions?: Apollo.QueryHookOptions<FullSalesforceRevenuePaginatedQuery, FullSalesforceRevenuePaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullSalesforceRevenuePaginatedQuery, FullSalesforceRevenuePaginatedQueryVariables>(FullSalesforceRevenuePaginatedDocument, options);
      }
export function useFullSalesforceRevenuePaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullSalesforceRevenuePaginatedQuery, FullSalesforceRevenuePaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullSalesforceRevenuePaginatedQuery, FullSalesforceRevenuePaginatedQueryVariables>(FullSalesforceRevenuePaginatedDocument, options);
        }
export type FullSalesforceRevenuePaginatedQueryHookResult = ReturnType<typeof useFullSalesforceRevenuePaginatedQuery>;
export type FullSalesforceRevenuePaginatedLazyQueryHookResult = ReturnType<typeof useFullSalesforceRevenuePaginatedLazyQuery>;
export type FullSalesforceRevenuePaginatedQueryResult = Apollo.QueryResult<FullSalesforceRevenuePaginatedQuery, FullSalesforceRevenuePaginatedQueryVariables>;
export const UsersRoleGroupDocument = gql`
    query UsersRoleGroup($role: UserRoleChoices) {
  usersRoleGroup(role: $role) {
    id
    firstName
    lastName
    isStaff
    role
  }
}
    `;

/**
 * __useUsersRoleGroupQuery__
 *
 * To run a query within a React component, call `useUsersRoleGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersRoleGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersRoleGroupQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUsersRoleGroupQuery(baseOptions?: Apollo.QueryHookOptions<UsersRoleGroupQuery, UsersRoleGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersRoleGroupQuery, UsersRoleGroupQueryVariables>(UsersRoleGroupDocument, options);
      }
export function useUsersRoleGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersRoleGroupQuery, UsersRoleGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersRoleGroupQuery, UsersRoleGroupQueryVariables>(UsersRoleGroupDocument, options);
        }
export type UsersRoleGroupQueryHookResult = ReturnType<typeof useUsersRoleGroupQuery>;
export type UsersRoleGroupLazyQueryHookResult = ReturnType<typeof useUsersRoleGroupLazyQuery>;
export type UsersRoleGroupQueryResult = Apollo.QueryResult<UsersRoleGroupQuery, UsersRoleGroupQueryVariables>;
export const BrandListDocument = gql`
    query BrandList {
  brandList {
    id
    name
  }
}
    `;

/**
 * __useBrandListQuery__
 *
 * To run a query within a React component, call `useBrandListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandListQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandListQuery(baseOptions?: Apollo.QueryHookOptions<BrandListQuery, BrandListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandListQuery, BrandListQueryVariables>(BrandListDocument, options);
      }
export function useBrandListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandListQuery, BrandListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandListQuery, BrandListQueryVariables>(BrandListDocument, options);
        }
export type BrandListQueryHookResult = ReturnType<typeof useBrandListQuery>;
export type BrandListLazyQueryHookResult = ReturnType<typeof useBrandListLazyQuery>;
export type BrandListQueryResult = Apollo.QueryResult<BrandListQuery, BrandListQueryVariables>;
export const PrecisionCategoriesListDocument = gql`
    query PrecisionCategoriesList {
  precisionCategoriesList {
    value
    label
    subItems {
      value
      label
      subItems {
        value
        label
        subItems {
          value
          label
        }
      }
    }
  }
}
    `;

/**
 * __usePrecisionCategoriesListQuery__
 *
 * To run a query within a React component, call `usePrecisionCategoriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrecisionCategoriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrecisionCategoriesListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrecisionCategoriesListQuery(baseOptions?: Apollo.QueryHookOptions<PrecisionCategoriesListQuery, PrecisionCategoriesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrecisionCategoriesListQuery, PrecisionCategoriesListQueryVariables>(PrecisionCategoriesListDocument, options);
      }
export function usePrecisionCategoriesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrecisionCategoriesListQuery, PrecisionCategoriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrecisionCategoriesListQuery, PrecisionCategoriesListQueryVariables>(PrecisionCategoriesListDocument, options);
        }
export type PrecisionCategoriesListQueryHookResult = ReturnType<typeof usePrecisionCategoriesListQuery>;
export type PrecisionCategoriesListLazyQueryHookResult = ReturnType<typeof usePrecisionCategoriesListLazyQuery>;
export type PrecisionCategoriesListQueryResult = Apollo.QueryResult<PrecisionCategoriesListQuery, PrecisionCategoriesListQueryVariables>;
export const PrecisionCategoriesOptionsDocument = gql`
    query PrecisionCategoriesOptions {
  precisionCategoriesOptions {
    id
    label
    children
    parents
  }
}
    `;

/**
 * __usePrecisionCategoriesOptionsQuery__
 *
 * To run a query within a React component, call `usePrecisionCategoriesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrecisionCategoriesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrecisionCategoriesOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrecisionCategoriesOptionsQuery(baseOptions?: Apollo.QueryHookOptions<PrecisionCategoriesOptionsQuery, PrecisionCategoriesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrecisionCategoriesOptionsQuery, PrecisionCategoriesOptionsQueryVariables>(PrecisionCategoriesOptionsDocument, options);
      }
export function usePrecisionCategoriesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrecisionCategoriesOptionsQuery, PrecisionCategoriesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrecisionCategoriesOptionsQuery, PrecisionCategoriesOptionsQueryVariables>(PrecisionCategoriesOptionsDocument, options);
        }
export type PrecisionCategoriesOptionsQueryHookResult = ReturnType<typeof usePrecisionCategoriesOptionsQuery>;
export type PrecisionCategoriesOptionsLazyQueryHookResult = ReturnType<typeof usePrecisionCategoriesOptionsLazyQuery>;
export type PrecisionCategoriesOptionsQueryResult = Apollo.QueryResult<PrecisionCategoriesOptionsQuery, PrecisionCategoriesOptionsQueryVariables>;
export const ReviewedUrlDocument = gql`
    query ReviewedUrl($url: String!) {
  reviewedUrl(url: $url) {
    url
    createdAt
    precisionIabV3
    originalClassification
    reviewedClassification
    rejectedClassification
    reviewedBy {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useReviewedUrlQuery__
 *
 * To run a query within a React component, call `useReviewedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewedUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useReviewedUrlQuery(baseOptions: Apollo.QueryHookOptions<ReviewedUrlQuery, ReviewedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewedUrlQuery, ReviewedUrlQueryVariables>(ReviewedUrlDocument, options);
      }
export function useReviewedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewedUrlQuery, ReviewedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewedUrlQuery, ReviewedUrlQueryVariables>(ReviewedUrlDocument, options);
        }
export type ReviewedUrlQueryHookResult = ReturnType<typeof useReviewedUrlQuery>;
export type ReviewedUrlLazyQueryHookResult = ReturnType<typeof useReviewedUrlLazyQuery>;
export type ReviewedUrlQueryResult = Apollo.QueryResult<ReviewedUrlQuery, ReviewedUrlQueryVariables>;
export const PredictiveCorrectionsDocument = gql`
    query PredictiveCorrections($predictedFromUrl: String!) {
  predictiveCorrections(predictedFromUrl: $predictedFromUrl) {
    url
    predictedFrom
    predictedCorrection
    id
    isApproved
  }
}
    `;

/**
 * __usePredictiveCorrectionsQuery__
 *
 * To run a query within a React component, call `usePredictiveCorrectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictiveCorrectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictiveCorrectionsQuery({
 *   variables: {
 *      predictedFromUrl: // value for 'predictedFromUrl'
 *   },
 * });
 */
export function usePredictiveCorrectionsQuery(baseOptions: Apollo.QueryHookOptions<PredictiveCorrectionsQuery, PredictiveCorrectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictiveCorrectionsQuery, PredictiveCorrectionsQueryVariables>(PredictiveCorrectionsDocument, options);
      }
export function usePredictiveCorrectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictiveCorrectionsQuery, PredictiveCorrectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictiveCorrectionsQuery, PredictiveCorrectionsQueryVariables>(PredictiveCorrectionsDocument, options);
        }
export type PredictiveCorrectionsQueryHookResult = ReturnType<typeof usePredictiveCorrectionsQuery>;
export type PredictiveCorrectionsLazyQueryHookResult = ReturnType<typeof usePredictiveCorrectionsLazyQuery>;
export type PredictiveCorrectionsQueryResult = Apollo.QueryResult<PredictiveCorrectionsQuery, PredictiveCorrectionsQueryVariables>;
export const ReviewedUrlsListPaginatedDocument = gql`
    query ReviewedUrlsListPaginated($publisher: PublisherChoicesEnum!, $search: String, $category: String, $dateRange: ReviewedUrlsDateRangePresetsEnum, $offset: Int, $before: String, $after: String, $first: Int, $last: Int, $filterStartDate: Date, $filterEndDate: Date) {
  reviewedUrlsListPaginated(
    publisher: $publisher
    search: $search
    category: $category
    dateRange: $dateRange
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    filterStartDate: $filterStartDate
    filterEndDate: $filterEndDate
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        url
      }
    }
    totalCount
  }
}
    `;

/**
 * __useReviewedUrlsListPaginatedQuery__
 *
 * To run a query within a React component, call `useReviewedUrlsListPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewedUrlsListPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewedUrlsListPaginatedQuery({
 *   variables: {
 *      publisher: // value for 'publisher'
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      dateRange: // value for 'dateRange'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filterStartDate: // value for 'filterStartDate'
 *      filterEndDate: // value for 'filterEndDate'
 *   },
 * });
 */
export function useReviewedUrlsListPaginatedQuery(baseOptions: Apollo.QueryHookOptions<ReviewedUrlsListPaginatedQuery, ReviewedUrlsListPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewedUrlsListPaginatedQuery, ReviewedUrlsListPaginatedQueryVariables>(ReviewedUrlsListPaginatedDocument, options);
      }
export function useReviewedUrlsListPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewedUrlsListPaginatedQuery, ReviewedUrlsListPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewedUrlsListPaginatedQuery, ReviewedUrlsListPaginatedQueryVariables>(ReviewedUrlsListPaginatedDocument, options);
        }
export type ReviewedUrlsListPaginatedQueryHookResult = ReturnType<typeof useReviewedUrlsListPaginatedQuery>;
export type ReviewedUrlsListPaginatedLazyQueryHookResult = ReturnType<typeof useReviewedUrlsListPaginatedLazyQuery>;
export type ReviewedUrlsListPaginatedQueryResult = Apollo.QueryResult<ReviewedUrlsListPaginatedQuery, ReviewedUrlsListPaginatedQueryVariables>;
export const ReviewedUrlsListPaginatedDownloadDocument = gql`
    query ReviewedUrlsListPaginatedDownload($publisher: PublisherChoicesEnum!, $search: String, $category: String, $dateRange: ReviewedUrlsDateRangePresetsEnum, $filterStartDate: Date, $filterEndDate: Date, $offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
  reviewedUrlsListPaginated(
    publisher: $publisher
    search: $search
    category: $category
    dateRange: $dateRange
    filterStartDate: $filterStartDate
    filterEndDate: $filterEndDate
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        url
        reviewedClassification
        rejectedClassification
        originalClassification
        createdAt
        reviewedBy {
          email
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useReviewedUrlsListPaginatedDownloadQuery__
 *
 * To run a query within a React component, call `useReviewedUrlsListPaginatedDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewedUrlsListPaginatedDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewedUrlsListPaginatedDownloadQuery({
 *   variables: {
 *      publisher: // value for 'publisher'
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      dateRange: // value for 'dateRange'
 *      filterStartDate: // value for 'filterStartDate'
 *      filterEndDate: // value for 'filterEndDate'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useReviewedUrlsListPaginatedDownloadQuery(baseOptions: Apollo.QueryHookOptions<ReviewedUrlsListPaginatedDownloadQuery, ReviewedUrlsListPaginatedDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewedUrlsListPaginatedDownloadQuery, ReviewedUrlsListPaginatedDownloadQueryVariables>(ReviewedUrlsListPaginatedDownloadDocument, options);
      }
export function useReviewedUrlsListPaginatedDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewedUrlsListPaginatedDownloadQuery, ReviewedUrlsListPaginatedDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewedUrlsListPaginatedDownloadQuery, ReviewedUrlsListPaginatedDownloadQueryVariables>(ReviewedUrlsListPaginatedDownloadDocument, options);
        }
export type ReviewedUrlsListPaginatedDownloadQueryHookResult = ReturnType<typeof useReviewedUrlsListPaginatedDownloadQuery>;
export type ReviewedUrlsListPaginatedDownloadLazyQueryHookResult = ReturnType<typeof useReviewedUrlsListPaginatedDownloadLazyQuery>;
export type ReviewedUrlsListPaginatedDownloadQueryResult = Apollo.QueryResult<ReviewedUrlsListPaginatedDownloadQuery, ReviewedUrlsListPaginatedDownloadQueryVariables>;
export const PredictiveCorrectionsListPaginatedDocument = gql`
    query predictiveCorrectionsListPaginated($search: String, $category: String, $offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
  predictiveCorrectionsListPaginated(
    search: $search
    category: $category
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        predictedFrom
      }
    }
    totalCount
  }
}
    `;

/**
 * __usePredictiveCorrectionsListPaginatedQuery__
 *
 * To run a query within a React component, call `usePredictiveCorrectionsListPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictiveCorrectionsListPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictiveCorrectionsListPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePredictiveCorrectionsListPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<PredictiveCorrectionsListPaginatedQuery, PredictiveCorrectionsListPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictiveCorrectionsListPaginatedQuery, PredictiveCorrectionsListPaginatedQueryVariables>(PredictiveCorrectionsListPaginatedDocument, options);
      }
export function usePredictiveCorrectionsListPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictiveCorrectionsListPaginatedQuery, PredictiveCorrectionsListPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictiveCorrectionsListPaginatedQuery, PredictiveCorrectionsListPaginatedQueryVariables>(PredictiveCorrectionsListPaginatedDocument, options);
        }
export type PredictiveCorrectionsListPaginatedQueryHookResult = ReturnType<typeof usePredictiveCorrectionsListPaginatedQuery>;
export type PredictiveCorrectionsListPaginatedLazyQueryHookResult = ReturnType<typeof usePredictiveCorrectionsListPaginatedLazyQuery>;
export type PredictiveCorrectionsListPaginatedQueryResult = Apollo.QueryResult<PredictiveCorrectionsListPaginatedQuery, PredictiveCorrectionsListPaginatedQueryVariables>;
export const OptimisationLogsDocument = gql`
    query optimisationLogs($campaignId: ID, $startDate: Date!, $endDate: Date!) {
  optimisationLogs(
    campaignId: $campaignId
    startDate: $startDate
    endDate: $endDate
  ) {
    createdAt
    taskName
    user {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useOptimisationLogsQuery__
 *
 * To run a query within a React component, call `useOptimisationLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimisationLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimisationLogsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useOptimisationLogsQuery(baseOptions: Apollo.QueryHookOptions<OptimisationLogsQuery, OptimisationLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimisationLogsQuery, OptimisationLogsQueryVariables>(OptimisationLogsDocument, options);
      }
export function useOptimisationLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimisationLogsQuery, OptimisationLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimisationLogsQuery, OptimisationLogsQueryVariables>(OptimisationLogsDocument, options);
        }
export type OptimisationLogsQueryHookResult = ReturnType<typeof useOptimisationLogsQuery>;
export type OptimisationLogsLazyQueryHookResult = ReturnType<typeof useOptimisationLogsLazyQuery>;
export type OptimisationLogsQueryResult = Apollo.QueryResult<OptimisationLogsQuery, OptimisationLogsQueryVariables>;
export const AvailableCampaignsDocument = gql`
    query availableCampaigns {
  availableCampaigns {
    campaign {
      id
      name
      dspSpecific
      dspInfo {
        dspName
      }
    }
    tableName
  }
}
    `;

/**
 * __useAvailableCampaignsQuery__
 *
 * To run a query within a React component, call `useAvailableCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableCampaignsQuery, AvailableCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCampaignsQuery, AvailableCampaignsQueryVariables>(AvailableCampaignsDocument, options);
      }
export function useAvailableCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCampaignsQuery, AvailableCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCampaignsQuery, AvailableCampaignsQueryVariables>(AvailableCampaignsDocument, options);
        }
export type AvailableCampaignsQueryHookResult = ReturnType<typeof useAvailableCampaignsQuery>;
export type AvailableCampaignsLazyQueryHookResult = ReturnType<typeof useAvailableCampaignsLazyQuery>;
export type AvailableCampaignsQueryResult = Apollo.QueryResult<AvailableCampaignsQuery, AvailableCampaignsQueryVariables>;
export const CampaignListDocument = gql`
    query campaignList($search: String, $filter: CampaignStatusChoices) {
  campaignList(search: $search, filter: $filter) {
    name
    id
    dspInfo {
      dspName
    }
    dspSpecific
  }
}
    `;

/**
 * __useCampaignListQuery__
 *
 * To run a query within a React component, call `useCampaignListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCampaignListQuery(baseOptions?: Apollo.QueryHookOptions<CampaignListQuery, CampaignListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignListQuery, CampaignListQueryVariables>(CampaignListDocument, options);
      }
export function useCampaignListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignListQuery, CampaignListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignListQuery, CampaignListQueryVariables>(CampaignListDocument, options);
        }
export type CampaignListQueryHookResult = ReturnType<typeof useCampaignListQuery>;
export type CampaignListLazyQueryHookResult = ReturnType<typeof useCampaignListLazyQuery>;
export type CampaignListQueryResult = Apollo.QueryResult<CampaignListQuery, CampaignListQueryVariables>;
export const OptimisationPackageInfoDocument = gql`
    query OptimisationPackageInfo($id: ID!) {
  optimisationPackageInfo(id: $id) {
    name
    startDate
    endDate
    active
    externalId
    orderId
    learnFromIds
    domains
  }
}
    `;

/**
 * __useOptimisationPackageInfoQuery__
 *
 * To run a query within a React component, call `useOptimisationPackageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimisationPackageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimisationPackageInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOptimisationPackageInfoQuery(baseOptions: Apollo.QueryHookOptions<OptimisationPackageInfoQuery, OptimisationPackageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimisationPackageInfoQuery, OptimisationPackageInfoQueryVariables>(OptimisationPackageInfoDocument, options);
      }
export function useOptimisationPackageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimisationPackageInfoQuery, OptimisationPackageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimisationPackageInfoQuery, OptimisationPackageInfoQueryVariables>(OptimisationPackageInfoDocument, options);
        }
export type OptimisationPackageInfoQueryHookResult = ReturnType<typeof useOptimisationPackageInfoQuery>;
export type OptimisationPackageInfoLazyQueryHookResult = ReturnType<typeof useOptimisationPackageInfoLazyQuery>;
export type OptimisationPackageInfoQueryResult = Apollo.QueryResult<OptimisationPackageInfoQuery, OptimisationPackageInfoQueryVariables>;
export const OptimisationPackageListPaginatedDocument = gql`
    query OptimisationPackageListPaginated($search: String, $isActive: Boolean, $first: Int, $offset: Int) {
  optimisationPackageListPaginated(
    search: $search
    isActive: $isActive
    first: $first
    offset: $offset
  ) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        uniqueId
        name
        startDate
        endDate
        partner
        active
      }
    }
  }
}
    `;

/**
 * __useOptimisationPackageListPaginatedQuery__
 *
 * To run a query within a React component, call `useOptimisationPackageListPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimisationPackageListPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimisationPackageListPaginatedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      isActive: // value for 'isActive'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useOptimisationPackageListPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<OptimisationPackageListPaginatedQuery, OptimisationPackageListPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimisationPackageListPaginatedQuery, OptimisationPackageListPaginatedQueryVariables>(OptimisationPackageListPaginatedDocument, options);
      }
export function useOptimisationPackageListPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimisationPackageListPaginatedQuery, OptimisationPackageListPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimisationPackageListPaginatedQuery, OptimisationPackageListPaginatedQueryVariables>(OptimisationPackageListPaginatedDocument, options);
        }
export type OptimisationPackageListPaginatedQueryHookResult = ReturnType<typeof useOptimisationPackageListPaginatedQuery>;
export type OptimisationPackageListPaginatedLazyQueryHookResult = ReturnType<typeof useOptimisationPackageListPaginatedLazyQuery>;
export type OptimisationPackageListPaginatedQueryResult = Apollo.QueryResult<OptimisationPackageListPaginatedQuery, OptimisationPackageListPaginatedQueryVariables>;
export const PredictiveCorrectionsStatusDocument = gql`
    query predictiveCorrectionsStatus($url: String!) {
  predictiveCorrectionsStatus(url: $url) {
    url
    isApproved
    originalClassification
    predictedCorrection
  }
}
    `;

/**
 * __usePredictiveCorrectionsStatusQuery__
 *
 * To run a query within a React component, call `usePredictiveCorrectionsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictiveCorrectionsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictiveCorrectionsStatusQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function usePredictiveCorrectionsStatusQuery(baseOptions: Apollo.QueryHookOptions<PredictiveCorrectionsStatusQuery, PredictiveCorrectionsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictiveCorrectionsStatusQuery, PredictiveCorrectionsStatusQueryVariables>(PredictiveCorrectionsStatusDocument, options);
      }
export function usePredictiveCorrectionsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictiveCorrectionsStatusQuery, PredictiveCorrectionsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictiveCorrectionsStatusQuery, PredictiveCorrectionsStatusQueryVariables>(PredictiveCorrectionsStatusDocument, options);
        }
export type PredictiveCorrectionsStatusQueryHookResult = ReturnType<typeof usePredictiveCorrectionsStatusQuery>;
export type PredictiveCorrectionsStatusLazyQueryHookResult = ReturnType<typeof usePredictiveCorrectionsStatusLazyQuery>;
export type PredictiveCorrectionsStatusQueryResult = Apollo.QueryResult<PredictiveCorrectionsStatusQuery, PredictiveCorrectionsStatusQueryVariables>;
export const SegmentBundleListDocument = gql`
    query SegmentBundleList {
  segmentBundleList {
    id
    segment {
      id
      name
    }
    deal {
      id
      name
    }
  }
}
    `;

/**
 * __useSegmentBundleListQuery__
 *
 * To run a query within a React component, call `useSegmentBundleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentBundleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentBundleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentBundleListQuery(baseOptions?: Apollo.QueryHookOptions<SegmentBundleListQuery, SegmentBundleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentBundleListQuery, SegmentBundleListQueryVariables>(SegmentBundleListDocument, options);
      }
export function useSegmentBundleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentBundleListQuery, SegmentBundleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentBundleListQuery, SegmentBundleListQueryVariables>(SegmentBundleListDocument, options);
        }
export type SegmentBundleListQueryHookResult = ReturnType<typeof useSegmentBundleListQuery>;
export type SegmentBundleListLazyQueryHookResult = ReturnType<typeof useSegmentBundleListLazyQuery>;
export type SegmentBundleListQueryResult = Apollo.QueryResult<SegmentBundleListQuery, SegmentBundleListQueryVariables>;
export const CampaignBundleListDocument = gql`
    query CampaignBundleList($campaignId: ID!) {
  campaignBundleList(campaignId: $campaignId) {
    id
    segment {
      id
      name
      segmentId
    }
    deal {
      id
      name
      dealId
    }
  }
}
    `;

/**
 * __useCampaignBundleListQuery__
 *
 * To run a query within a React component, call `useCampaignBundleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignBundleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignBundleListQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignBundleListQuery(baseOptions: Apollo.QueryHookOptions<CampaignBundleListQuery, CampaignBundleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignBundleListQuery, CampaignBundleListQueryVariables>(CampaignBundleListDocument, options);
      }
export function useCampaignBundleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignBundleListQuery, CampaignBundleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignBundleListQuery, CampaignBundleListQueryVariables>(CampaignBundleListDocument, options);
        }
export type CampaignBundleListQueryHookResult = ReturnType<typeof useCampaignBundleListQuery>;
export type CampaignBundleListLazyQueryHookResult = ReturnType<typeof useCampaignBundleListLazyQuery>;
export type CampaignBundleListQueryResult = Apollo.QueryResult<CampaignBundleListQuery, CampaignBundleListQueryVariables>;
export const BundleContextHandlerDocument = gql`
    mutation BundleContextHandler($campaignId: ID!, $dspTacticIds: [String]!, $dspTacticLevel: LineTypeChoicesEnum!, $segmentBundleIds: [ID]!, $nonIllumaTacticIds: [String]) {
  segmentBundleContextHandler(
    campaignId: $campaignId
    dspTacticIds: $dspTacticIds
    dspTacticLevel: $dspTacticLevel
    segmentBundleIds: $segmentBundleIds
    nonIllumaTacticIds: $nonIllumaTacticIds
  ) {
    bundleContexts {
      campaign {
        name
      }
    }
  }
}
    `;
export type BundleContextHandlerMutationFn = Apollo.MutationFunction<BundleContextHandlerMutation, BundleContextHandlerMutationVariables>;

/**
 * __useBundleContextHandlerMutation__
 *
 * To run a mutation, you first call `useBundleContextHandlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBundleContextHandlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bundleContextHandlerMutation, { data, loading, error }] = useBundleContextHandlerMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      dspTacticIds: // value for 'dspTacticIds'
 *      dspTacticLevel: // value for 'dspTacticLevel'
 *      segmentBundleIds: // value for 'segmentBundleIds'
 *      nonIllumaTacticIds: // value for 'nonIllumaTacticIds'
 *   },
 * });
 */
export function useBundleContextHandlerMutation(baseOptions?: Apollo.MutationHookOptions<BundleContextHandlerMutation, BundleContextHandlerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BundleContextHandlerMutation, BundleContextHandlerMutationVariables>(BundleContextHandlerDocument, options);
      }
export type BundleContextHandlerMutationHookResult = ReturnType<typeof useBundleContextHandlerMutation>;
export type BundleContextHandlerMutationResult = Apollo.MutationResult<BundleContextHandlerMutation>;
export type BundleContextHandlerMutationOptions = Apollo.BaseMutationOptions<BundleContextHandlerMutation, BundleContextHandlerMutationVariables>;
export const SegmentContextItemDocument = gql`
    query SegmentContextItem($campaignId: ID) {
  segmentContextItem(campaignId: $campaignId) {
    id
    campaign {
      id
      name
      dspInfo {
        dspName
      }
    }
    bundle {
      id
      segment {
        id
        name
        segmentId
      }
      deal {
        id
        name
        dealId
      }
    }
    lineType
    relevantIds
    nonIllumaIds
  }
}
    `;

/**
 * __useSegmentContextItemQuery__
 *
 * To run a query within a React component, call `useSegmentContextItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentContextItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentContextItemQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useSegmentContextItemQuery(baseOptions?: Apollo.QueryHookOptions<SegmentContextItemQuery, SegmentContextItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentContextItemQuery, SegmentContextItemQueryVariables>(SegmentContextItemDocument, options);
      }
export function useSegmentContextItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentContextItemQuery, SegmentContextItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentContextItemQuery, SegmentContextItemQueryVariables>(SegmentContextItemDocument, options);
        }
export type SegmentContextItemQueryHookResult = ReturnType<typeof useSegmentContextItemQuery>;
export type SegmentContextItemLazyQueryHookResult = ReturnType<typeof useSegmentContextItemLazyQuery>;
export type SegmentContextItemQueryResult = Apollo.QueryResult<SegmentContextItemQuery, SegmentContextItemQueryVariables>;
export const SegmentListDocument = gql`
    query SegmentList {
  segmentList {
    id
    name
    segmentId
    bundles {
      id
      segment {
        id
        name
      }
      deal {
        id
        name
        dealId
      }
    }
  }
}
    `;

/**
 * __useSegmentListQuery__
 *
 * To run a query within a React component, call `useSegmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentListQuery(baseOptions?: Apollo.QueryHookOptions<SegmentListQuery, SegmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentListQuery, SegmentListQueryVariables>(SegmentListDocument, options);
      }
export function useSegmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentListQuery, SegmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentListQuery, SegmentListQueryVariables>(SegmentListDocument, options);
        }
export type SegmentListQueryHookResult = ReturnType<typeof useSegmentListQuery>;
export type SegmentListLazyQueryHookResult = ReturnType<typeof useSegmentListLazyQuery>;
export type SegmentListQueryResult = Apollo.QueryResult<SegmentListQuery, SegmentListQueryVariables>;
export const DealListDocument = gql`
    query DealList {
  dealList {
    id
    name
    dealId
    bundles {
      id
      segment {
        id
        name
        segmentId
      }
      deal {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDealListQuery__
 *
 * To run a query within a React component, call `useDealListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealListQuery(baseOptions?: Apollo.QueryHookOptions<DealListQuery, DealListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealListQuery, DealListQueryVariables>(DealListDocument, options);
      }
export function useDealListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealListQuery, DealListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealListQuery, DealListQueryVariables>(DealListDocument, options);
        }
export type DealListQueryHookResult = ReturnType<typeof useDealListQuery>;
export type DealListLazyQueryHookResult = ReturnType<typeof useDealListLazyQuery>;
export type DealListQueryResult = Apollo.QueryResult<DealListQuery, DealListQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  userLogin(email: $email, password: $password) {
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const GetUserDetailsDocument = gql`
    query GetUserDetails {
  me {
    id
    firstName
    lastName
    isStaff
    role
    agency {
      partner
      name
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($userEmail: String!) {
  passwordReset(userEmail: $userEmail) {
    response
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;